<template>
  <div>
    <div ref="tripInfoPanel" class="trip-info"
      :style="{ 'display': (isExpandedNum != 2 && processedTrackData.length > 0 && showTripInfo) ? 'block' : 'none', 'left': isCollapsed ? '0' : '23rem', bottom: captureFloatingBottom }">
      <header class="trip-info__header">
        <span class="trip-info__plate" :class="{ 'is-consig': isConsigMode }">{{ tripInfoHeaderDisplay }}</span>
        <div class="trip-info__actions">
          <el-button type="text" size="mini" class="trip-info__icon-btn" @click="openTripEditDialog">
            <i class="el-icon-edit"></i>
          </el-button>
          <el-button type="text" size="mini" class="trip-info__icon-btn" v-permission="'truck:export'" @click="downloadTripViewportScreenshot">
            <i class="el-icon-picture"></i>
        </el-button>
          <el-button type="text" size="mini" class="trip-info__icon-btn" @click="copyTripInfo">
            <i class="el-icon-document-copy"></i>
          </el-button>
          <el-button type="text" size="mini" class="trip-info__icon-btn trip-info__icon-btn--close" @click="closeTripInfo">
            <i class="el-icon-close"></i>
        </el-button>
      </div>
      </header>
      <div class="trip-info__summary">
        <span class="trip-info__summary-item">车机总里程：<em>{{ displayTripSummary.distance }}</em></span>
        <span class="trip-info__summary-item">总耗时：<em>{{ displayTripSummary.duration }}</em></span>
        <!-- <span class="trip-info__summary-item">已行驶：<em>{{ playedDistanceStr }}</em></span> -->
      </div>
      <div class="trip-info__body">
        <div class="trip-section">
          <h4 class="trip-section__title">开始：{{ tripStartInfo ? tripStartInfo.time : '暂无数据' }}</h4>
          <div class="trip-section__coords">
            <span>经度：{{ tripStartCoordinateDisplay.lon }}</span>
            <span>纬度：{{ tripStartCoordinateDisplay.lat }}</span>
          </div>
          <p class="trip-section__addr">{{ tripStartLocationDisplay }}</p>
        </div>
        <div class="trip-section">
          <h4 class="trip-section__title">结束：{{ tripEndInfo ? tripEndInfo.time : '暂无数据' }}</h4>
          <div class="trip-section__coords">
            <span>经度：{{ tripEndCoordinateDisplay.lon }}</span>
            <span>纬度：{{ tripEndCoordinateDisplay.lat }}</span>
          </div>
          <p class="trip-section__addr">{{ tripEndLocationDisplay }}</p>
        </div>
      </div>
    </div>
    <!-- 行程信息弹窗 -->
    <div class="trip-info-popup"
      :style="{ 'width': isCollapsed ? '100%' : 'calc(100% - 23rem)', 'height': isExpandedNum == 2 ? '100%' : 'auto', 'left': isCollapsed ? '0' : '23rem' }">
      <!-- 外层通栏右对齐；内层条宽度随按钮（非 100%） -->
      <div class="function-buttons-row" :style="{ 'display': isExpandedNum != 2 ? 'block' : 'none', 'bottom': captureFloatingBottom }">
        <div class="function-buttons">
<!--          <el-button type="primary" plain>AI分析里程</el-button>-->
<!--          <el-button type="primary" plain>AI轨迹报告</el-button>-->
          <el-button type="primary" plain class="function-buttons__export" v-permission="'truck:export'" @click="openExportDialog">数据导出</el-button>
        </div>
      </div>
      <!-- 视频播放器 -->
      <div class="video-player" :style="{ 'display': (hidePlaybackForCapture || isExpandedNum == 2) ? 'none' : 'block' }">
        <div class="player-controls">
          <div class="player-controls__left">
            <template v-if="!isPlaying">
              <i style="font-size: 2rem; cursor: pointer;" class="el-icon-video-play" @click="playTrack"></i>
              <img src="@/assets/close.png" alt="" class="el-icon-video-pause" />
            </template>
            <template v-else>
              <i style="font-size: 2rem; cursor: pointer;color: #467cfd;" class="el-icon-video-pause"
                @click="pauseTrack"></i>
              <img src="@/assets/closeBlack.png" alt="" @click="pauseTrack" class="el-icon-video-pause" />
            </template>
            <span class="time-display">{{ currentTime }}</span>
          </div>
          <div class="player-controls__track">
            <el-slider v-model="videoProgress" :max="100" size="small" class="progress-slider"
              tooltip-class="trip-player-slider-tooltip"
              :format-tooltip="formatSliderTooltip" @input="onProgressInput"
              @change="onProgressChange"></el-slider>
            <div v-if="qualityMode" class="quality-time-gaps" aria-label="缺报空档">
              <span v-for="gap in qualityTimeGaps" :key="gap.key" :style="{ left: gap.left + '%', width: gap.width + '%' }" :title="'缺报 ' + gap.seconds + ' 秒'" />
            </div>
            <PlaybackRangeBar
              :points="fullSpeedChartPoints"
              :range-start="playbackRangeBarStart"
              :range-end="playbackRangeBarEnd"
              :progress-ratio="playbackProgressRatioFull"
              :loading="playbackRangeDragging"
              @range-change="onPlaybackRangeChange"
            />
          </div>
          <div class="player-controls__right">
            <span class="time-display">{{ totalTime }}</span>
            <div
              ref="speedPicker"
              class="speed-picker"
              @click.stop
            >
              <button
                type="button"
                class="speed-picker__trigger"
                :class="{ 'is-open': speedMenuOpen }"
                @click="toggleSpeedMenu"
              >
                <span>x{{ playbackSpeed }}</span>
                <i class="el-icon-arrow-down speed-picker__caret"></i>
              </button>
              <transition name="speed-picker-fade">
                <div
                  v-show="speedMenuOpen"
                  class="speed-picker__dropdown"
                  role="listbox"
                >
                  <ul class="speed-picker__list">
                    <li
                      v-for="opt in speedOptions"
                      :key="opt.value"
                      class="speed-picker__item"
                      :class="{ 'is-active': playbackSpeed === opt.value }"
                      role="option"
                      @click="selectPlaybackSpeed(opt.value)"
                    >
                      {{ opt.label }}
                    </li>
                  </ul>
                  <div class="speed-picker__arrow" aria-hidden="true"></div>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>

      <!-- 标签页 -->
      <div style="position: relative;z-index: 999;"
        :style="{ 'height': isExpandedNum == 1 ? '35%' : '100%', 'display': isExpandedNum == 3 ? 'none' : 'block' }">
        <div class="expand-controls">
          <div
          v-if="isExpandedNum == 1"
      class="expand-btn"
      role="button"
      tabindex="0"
      aria-label="展开或收起侧栏"
      @click="collapsePanel(2)"
    >
      <i style="color: #fff;" class="el-icon-caret-top"></i>
    </div>
    <div
          v-if="isExpandedNum == 1"
      class="expand-btn"
      role="button"
      tabindex="0"
      aria-label="展开或收起侧栏"
      @click="collapsePanel(3)"
    >
      <i style="color: #fff;" class="el-icon-caret-bottom"></i>
    </div>
        </div>
        <el-tabs v-model="activeTab" :style="{ 'height': isExpandedNum == 1 ? '256px' : '100%' }">
          <el-tab-pane label="停靠点明细" name="first">
            <el-table border stripe class="right-data-el-table" style="margin-bottom: 0.625rem;"
              :data="currentParkingData"
              :style="{ 'height': isExpandedNum == 1 ? '9rem' : '33rem' }"
              @row-click="goToMapParking"
              @cell-mouse-enter="onParkingTableCellEnter">
              <el-table-column type="index" label="序号" width="80"></el-table-column>
              <el-table-column v-if="runRoute.some(item => item.waybillNo)" prop="waybillNo" label="运单号" min-width="160"></el-table-column>
              <el-table-column prop="duration" label="停车时长"></el-table-column>
              <el-table-column prop="startTime" label="停车开始时间"></el-table-column>
              <el-table-column prop="endTime" label="停车结束时间"></el-table-column>
              <el-table-column label="停车位置">
                <template slot-scope="scope">
                  <span @click="goToMapParking(scope.row)" class="layout-theme-text" style="cursor: pointer;">
                    {{ scope.row.location || '鼠标移上获取位置...' }}
                  </span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination @size-change="handleParkingSizeChange" @current-change="handleParkingCurrentChange"
              :current-page="parkingPageNum" :page-sizes="[10, 20, 50, 100]" :page-size="parkingPageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="rangeFilteredParkingData.length">
            </el-pagination>
          </el-tab-pane>
          <el-tab-pane label="轨迹明细" name="second">
            <el-table border stripe class="right-data-el-table" style="margin-bottom: 0.625rem;"
              :class="{ 'right-data-el-table--quality': qualityMode }"
              :data="currentTrackData"
              :style="{ 'height': isExpandedNum == 1 ? '9rem' : '33rem' }"
              @row-click="goToMap"
              @cell-mouse-enter="onTrackTableCellEnter">
              <el-table-column v-if="runRoute.some(item => item.waybillNo)" prop="waybillNo" label="运单号" min-width="160"></el-table-column>
              <el-table-column prop="time" label="时间" :min-width="qualityMode ? 190 : undefined"></el-table-column>
              <el-table-column prop="speed" label="速度" :min-width="qualityMode ? 110 : undefined"></el-table-column>
              <el-table-column v-if="qualityMode" prop="wgsLongitude" label="原始经度" min-width="120" />
              <el-table-column v-if="qualityMode" prop="wgsLatitude" label="原始纬度" min-width="120" />
              <el-table-column v-if="qualityMode" prop="qualityText" label="质量" min-width="140" show-overflow-tooltip />
              <el-table-column prop="mil" label="上报里程(km)" :min-width="qualityMode ? 130 : undefined"></el-table-column>
              <el-table-column prop="agl" label="方向" :min-width="qualityMode ? 80 : undefined" :formatter="formatTrackDirectionCell"></el-table-column>
              <el-table-column prop="hgt" label="海拔" :min-width="qualityMode ? 80 : undefined"></el-table-column>
              <el-table-column label="位置" :min-width="qualityMode ? 260 : undefined" :show-overflow-tooltip="qualityMode">
                <template slot-scope="scope">
                  <span @click="goToMap(scope.row)" class="layout-theme-text" style="cursor: pointer;">
                    {{ scope.row.location || '鼠标移上获取位置...' }}
                  </span>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="coordinate" label="坐标"></el-table-column> -->
            </el-table>
            <el-pagination @size-change="handleTrackSizeChange" @current-change="handleTrackCurrentChange"
              :current-page="trackPageNum" :page-sizes="[10, 20, 50, 100]" :page-size="trackPageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="rangeFilteredTrackData.length">
            </el-pagination>
          </el-tab-pane>
          <el-tab-pane label="速度曲线" name="third">
            <SpeedCurvePanel
              :points="speedChartPoints"
              :quality-mode="qualityMode"
              @settings-saved="$emit('quality-settings-saved', $event)"
              :active="activeTab === 'third'"
              :height="isExpandedNum == 1 ? '9rem' : '33rem'"
              @point-click="onSpeedCurvePointClick"
            />
          </el-tab-pane>
        </el-tabs>
      </div>

    </div>
    <div class="expand-controls-fiex" :style="mapPanelAnchorStyle">
      <div
        v-if="isExpandedNum == 2"
        class="expand-btn expand-controls-top"
        role="button"
        tabindex="0"
        aria-label="展开或收起侧栏"
        @click="collapsePanel(1)"
      >
        <i style="color: #fff;" class="el-icon-caret-bottom"></i>
      </div>
      <div
        v-if="isExpandedNum == 3"
        class="expand-btn expand-controls-bottom"
        role="button"
        tabindex="0"
        aria-label="展开或收起侧栏"
        @click="collapsePanel(1)"
      >
        <i style="color: #fff;" class="el-icon-caret-top"></i>
      </div>
    </div>
    <el-dialog
      title="数据导出"
      :visible.sync="exportDialogVisible"
      width="26.25rem"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="export-dialog-body">
        <el-checkbox
          v-model="exportOptionParkingOnly"
          @change="onExportOptionParkingOnlyChange"
        >只解析停靠点地址</el-checkbox>
        <el-checkbox
          v-model="exportOptionFull"
          @change="onExportOptionFullChange"
        >全部解析</el-checkbox>
        <el-checkbox
          v-model="exportOptionNoAddress"
          @change="onExportOptionNoAddressChange"
        >不解析地址</el-checkbox>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportDialogVisible = false">关闭</el-button>
        <el-button type="primary" v-permission="'truck:export'" @click="confirmExportFromDialog">导出</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修正地址文案"
      :visible.sync="tripEditDialogVisible"
      width="780px"
      append-to-body
      :close-on-click-modal="false"
      custom-class="biz-dialog"
      @close="onTripEditDialogClose"
    >
      <div class="biz-dialog-section">
      <el-form ref="tripEditFormRef" :model="tripEditForm" label-width="110px" class="trip-edit-form">
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="tripEditForm.timeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%;"
            clearable
          />
        </el-form-item>
        <div class="form-row">
          <el-form-item label="开始坐标" class="form-item">
            <el-input v-model="tripEditForm.startCoord" placeholder="请选择坐标" clearable>
              <el-button slot="append" icon="el-icon-location" @click="openTripEditMapDialog('start')"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="结束坐标" class="form-item">
            <el-input v-model="tripEditForm.endCoord" placeholder="请选择坐标" clearable>
              <el-button slot="append" icon="el-icon-location" @click="openTripEditMapDialog('end')"></el-button>
            </el-input>
          </el-form-item>
        </div>
        <div class="form-row">
          <el-form-item label="开始地址" class="form-item">
            <el-input v-model="tripEditForm.startAddressDetail" placeholder="请输入开始地址" clearable />
          </el-form-item>
          <el-form-item label="结束地址" class="form-item">
            <el-input v-model="tripEditForm.endAddressDetail" placeholder="请输入结束地址" clearable />
          </el-form-item>
        </div>
      </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tripEditDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmTripEdit">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="选择坐标"
      :visible.sync="tripEditMapDialogVisible"
      width="70%"
      append-to-body
      custom-class="biz-dialog biz-dialog--map"
      @close="onTripEditMapDialogClose"
    >
      <div class="trip-edit-map-wrap">
        <div class="trip-edit-map-search">
          <el-autocomplete
            v-model="tripEditMapSearchText"
            :fetch-suggestions="queryTripEditSearchAsync"
            placeholder="请输入位置"
            style="width: 18.75rem;"
            @select="handleTripEditMapSelect"
            @keyup.enter.native="searchTripEditMapLocation"
            popper-append-to-body
            trigger-on-focus
            :highlight-first-item="true"
          >
            <el-button slot="append" icon="el-icon-search" @click="searchTripEditMapLocation"></el-button>
          </el-autocomplete>
        </div>
        <div ref="tripEditMapEl" class="trip-edit-map"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tripEditMapDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="正在解析地址"
      :visible.sync="exportRegeoProgressVisible"
      width="26.25rem"
      append-to-body
      :close-on-click-modal="false"
      :show-close="false"
      :close-on-press-escape="false"
      custom-class="biz-dialog"
    >
      <div class="biz-dialog-section">
        <el-progress :percentage="exportRegeoProgress" :stroke-width="16"></el-progress>
        <p class="export-regeo-progress-label">{{ exportRegeoProgressLabel }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" plain @click="cancelExportRegeo">取消导出</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
// 导入坐标转换工具
import coordtransform from '@/WGS84.js';
import request from '@/utils/request'
import { authState, hasPermission } from '@/utils/auth'
import { resolveAddressByCoord as resolveAddressByCoordUtil, isValidResolvedAddress, getGlobalCoordAddressCache } from '@/utils/coordAddressResolver'

import html2canvas from 'html2canvas';
import ExcelJS from 'exceljs';
import { writeTrajectoryTaskInfoBanner, writeTrajectoryDetailTableHeader, buildTrajectoryTaskMetadata } from '@/utils/localTrajectoryWorkbook';
import { saveAs } from 'file-saver';
import { buildAmapStaticMapUrlFromTrackPoints } from '@/utils/amapStaticMap';
import { tiandituDecodeCoordsSequential, tiandituDecodeCoordsConcurrent } from '@/utils/tiandituGeocoder';
import { Screenshot } from '@amap/screenshot';
import { setAmapSecurityConfig, loadAmapSDK } from '@/utils/amapConfig';
import SpeedCurvePanel from '@/components/SpeedCurvePanel.vue';
import playbackRangeMixin from '@/mixins/playbackRangeMixin';
import { buildSpeedChartPoints, handleSpeedCurvePointClick } from '@/utils/speedChartPoints';
import { buildTrajectoryExportFileName } from '@/utils/trajectoryExportFileName';

/* global AMap */

/** 与 TransportService.lonLatToGcj02 一致，保证折线与车标坐标同源 */
function lonLatToGcjLikeTransport(lon, lat) {
  const nlon = Number(lon)
  const nlat = Number(lat)
  if (Number.isNaN(nlon) || Number.isNaN(nlat)) return [0, 0]
  const useScaled = Math.max(Math.abs(nlon), Math.abs(nlat)) > 10000
  if (useScaled) {
    const lonWgs84 = nlon / 600000.0
    const latWgs84 = nlat / 600000.0
    return coordtransform.wgs84togcj02(lonWgs84, latWgs84)
  }
  return [nlon, nlat]
}

/** runRoute 原始 lon/lat → WGS84 十进制度（与历史轨迹页 ×600000 规则一致） */
function runRoutePointToWgsDeg(lon, lat) {
  const nlon = Number(lon)
  const nlat = Number(lat)
  if (!Number.isFinite(nlon) || !Number.isFinite(nlat)) return [0, 0]
  const useScaled = Math.max(Math.abs(nlon), Math.abs(nlat)) > 10000
  if (useScaled) {
    return [nlon / 600000, nlat / 600000]
  }
  return [nlon, nlat]
}

/** 与 RightDataNewTrack 一致：相邻点计算角度（正北 0°，顺时针） */
function calcAngle(a, b) {
  if (!a || !b) return null
  const aLon = Number(a.longitude)
  const aLat = Number(a.latitude)
  const bLon = Number(b.longitude)
  const bLat = Number(b.latitude)
  if (![aLon, aLat, bLon, bLat].every(Number.isFinite)) return null
  let dRotateAngle = Math.atan2(Math.abs(aLon - bLon), Math.abs(aLat - bLat))
  if (bLon >= aLon) {
    if (!(bLat >= aLat)) {
      dRotateAngle = Math.PI - dRotateAngle
    }
  } else if (bLat >= aLat) {
    dRotateAngle = 2 * Math.PI - dRotateAngle
  } else {
    dRotateAngle = Math.PI + dRotateAngle
  }
  return (dRotateAngle * 180) / Math.PI
}

/** 轨迹明细：接口无方向时由相邻点推算；单点 0 */
function computeTrackRowHeadingDeg(runRoute, index) {
  const n = runRoute.length
  if (n <= 1) return 0
  if (index < n - 1) {
    const a = runRoutePointToWgsDeg(runRoute[index].lon, runRoute[index].lat)
    const b = runRoutePointToWgsDeg(runRoute[index + 1].lon, runRoute[index + 1].lat)
    const deg = calcAngle(
      { longitude: a[0], latitude: a[1] },
      { longitude: b[0], latitude: b[1] }
    )
    return Number.isFinite(deg) ? Math.round(deg) : 0
  }
  const a = runRoutePointToWgsDeg(runRoute[index - 1].lon, runRoute[index - 1].lat)
  const b = runRoutePointToWgsDeg(runRoute[index].lon, runRoute[index].lat)
  const deg = calcAngle(
    { longitude: a[0], latitude: a[1] },
    { longitude: b[0], latitude: b[1] }
  )
  return Number.isFinite(deg) ? Math.round(deg) : 0
}

/** 正北 0°、顺时针角度 → 八方位字 */
function headingDegToCardinal8(deg) {
  const d = ((Number(deg) % 360) + 360) % 360
  if (d <= 22.5 || d > 337.5) return '北'
  if (d <= 67.5) return '东北'
  if (d <= 112.5) return '东'
  if (d <= 157.5) return '东南'
  if (d <= 202.5) return '南'
  if (d <= 247.5) return '西南'
  if (d <= 292.5) return '西'
  return '西北'
}

/** 轨迹明细展示：角度或已有方位字面 → 八方位 */
function directionToCardinal8(v) {
  if (['北', '东北', '东', '东南', '南', '西南', '西', '西北'].includes(v)) return v
  if (v != null && v !== '' && Number.isFinite(Number(v))) return headingDegToCardinal8(Number(v))
  return '北'
}

/** runRoute 点 gtm（yyyymmdd/hhmmss）→ 毫秒时间戳，供轨迹时间轴插值 */
function parseGtmToMs(gtm) {
  if (!gtm || String(gtm).length < 15) return null;
  try {
    const datePart = gtm.substring(0, 8);
    const timePart = gtm.substring(9);
    const year = datePart.substring(0, 4);
    const month = datePart.substring(4, 6);
    const day = datePart.substring(6, 8);
    const hour = timePart.substring(0, 2);
    const minute = timePart.substring(2, 4);
    const second = timePart.substring(4, 6);
    const d = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
    const t = d.getTime();
    return Number.isNaN(t) ? null : t;
  } catch (e) {
    return null;
  }
}

/** visualRoute 的 runRoute 点速度（km/h）：读 spd，并兼容大小写/别名与字符串中的数字 */
function parseRunRouteSpdKm(item) {
  if (!item || typeof item !== 'object') return 0
  const raw =
    item.spd != null && item.spd !== ''
      ? item.spd
      : item.SPD != null && item.SPD !== ''
        ? item.SPD
        : item.speed != null && item.speed !== ''
          ? item.speed
          : item.Speed != null && item.Speed !== ''
            ? item.Speed
            : null
  if (raw === null || raw === undefined || raw === '') return 0
  if (typeof raw === 'number') return Number.isFinite(raw) ? raw : 0
  const s = String(raw).trim().replace(/,/g, '')
  const m = s.match(/-?\d+(?:\.\d+)?/)
  if (!m) return 0
  const n = parseFloat(m[0])
  return Number.isFinite(n) ? n : 0
}

export default {
  name: 'RightDataPlugin',
  mixins: [playbackRangeMixin],
  components: {
    SpeedCurvePanel
  },
  props: {
    qualityMode: { type: Boolean, default: false },
    independentExportHandler: { type: Function, default: null },
    trajectoryShareEnabled: { type: Boolean, default: false },
    isCollapsed: {
      type: Boolean,
      default: false
    },
    isExpandedNum: {
      type: Number,
      default: 2
    },
    /** 截图/详情导出：隐藏底部播放条，底部区域仍整屏入画 */
    hidePlaybackForCapture: {
      type: Boolean,
      default: false
    },
    runRoute: {
      type: Array,
      default: () => []
    },
    parkingData: {
      type: Array,
      default: () => []
    },
    tripSummary: {
      type: Object,
      default: () => ({
        distance: '0km',
        duration: '0时0分0秒'
      })
    },
    /** 父组件已创建 AMapUI PathNavigator，车标由 navg 驱动 */
    pathNavigatorActive: {
      type: Boolean,
      default: false
    },
    /**
     * 非空时替代行程条头部的 localStorage 车牌展示（如历史轨迹 type=6 传 consigNo）
     */
    tripHeaderOverride: {
      type: String,
      default: ''
    },
    /** trajectorynewprocess 返回的 data.position 原对象，用于 processShare */
    
    /**
     * 为 true：行程头车牌用 localStorage（点击查询写入，与有「查询」按钮场景一致）；
     * 为 false：优先用接口 position.vehicleNo（与左侧「无查询按钮」时回显车牌一致，如分享 iframe）。
     */
    usePlateFromLocalStorage: {
      type: Boolean,
      default: true
    },
    /** 无查询按钮时接口回显车牌（与左侧输入框一致）；优先于 trajectoryPosition.vehicleNo */
    plateFromApi: {
      type: String,
      default: ''
    },
    /**
     * 有「查询」按钮时：父组件把“当前查询表单/输入框”的车牌直接传进来，
     * 行程条头部优先展示它；仅在为空时才回退 localStorage / 接口数据。
     */
    plateFromQuery: {
      type: String,
      default: ''
    },
    /** 起终点展示覆盖（仅改文案，不改轨迹） */
    displayOverride: {
      type: Object,
      default: null
    },
    /**
     * 地图子组件同步的起终点第二行文案（与地图上「起/终」标签完全一致）；
     * 为 null 时行程条仍按轨迹点 key 走本地/全局缓存解析。
     */
    mapTripEndpointLines: {
      type: Object,
      default: null
    },
    /** 仅 historicalTrajectoryNew 传 true，显示「分享」 */
    
    /** processShare 的 type：危化 HC，货车轨迹 history */
    
    /** 自定义分享内容；为空时沿用危化 trajectoryPosition */
    
  },
  data() {
    return {
      // 视频播放器
      videoProgress: 0,
      playbackSpeed: '20',
      speedMenuOpen: false,
      speedOptions: [
        { label: 'x1', value: '1' },
        { label: 'x5', value: '5' },
        { label: 'x10', value: '10' },
        { label: 'x20', value: '20' },
        { label: 'x50', value: '50' }
      ],
      // 标签页
      activeTab: 'first',
      // 轨迹数据（默认值，当 runRoute 为空时使用）
      trackData: [],
      // 位置缓存，避免重复调用逆地理编码
      locationCache: {},
      // 行程信息显示状态
      showTripInfo: false,
      // 停靠点分页
      parkingPageNum: 1,
      parkingPageSize: 20,
      // 轨迹分页
      trackPageNum: 1,
      trackPageSize: 20,
      // 播放状态
      isPlaying: false,
      /** 当前播放到第几秒（可小数），相对轨迹起点 */
      playElapsedSeconds: 0,
      playInterval: null,
      vehicleMarker: null,
      sliderDragging: false,
      /** 为 true 时忽略 Slider 因 v-model 回写触发的 @input，避免误判为拖动导致播放卡死 */
      suppressSliderSeek: false,
      /** 点击轨迹数据点预览：车标临时跳到该点，playElapsedSeconds 不变 */
      trackPointPreviewActive: false,
      // 时间相关
      currentTime: '00:00:00',
      totalTime: '00:00:00',
      exportDialogVisible: false,
      exportOptionParkingOnly: false,
      exportOptionFull: true,
      exportOptionNoAddress: false,
      exportRegeoProgressVisible: false,
      exportRegeoProgress: 0,
      exportRegeoProgressLabel: '',
      exportCancelRequested: false,
      /** 行程卡首尾地址：从全局坐标缓存回填 locationCache（地图子组件写入全局，非响应式） */
      tripAddrHydrateTimer: null,
      tripEditDialogVisible: false,
      tripEditOpenSnapshot: null,
      tripEditForm: {
        timeRange: null,
        startCoord: '',
        endCoord: '',
        startAddressDetail: '',
        endAddressDetail: ''
      },
      tripEditMapDialogVisible: false,
      tripEditMapTarget: 'start',
      tripEditMapSearchText: '',
      tripEditMapInstance: null,
      tripEditMapInitPromise: null
    }
  },
  computed: {
    parkingDataIdentity() {
      return JSON.stringify((this.parkingData || []).map(item => [item.waybillNo, item.startTime, item.endTime, item.lon, item.lat]))
    },
    qualityTimeGaps() {
      const points = this.processedTrackData
      if (!this.qualityMode || points.length < 2) return []
      const start = points[0].timeMs
      const duration = points[points.length - 1].timeMs - start
      if (duration <= 0) return []
      return points.flatMap((point, index) => index && point.segmentKey !== points[index - 1].segmentKey ? [{ key: point.pointKey, left: (points[index - 1].timeMs - start) / duration * 100, width: (point.timeMs - points[index - 1].timeMs) / duration * 100, seconds: (point.timeMs - points[index - 1].timeMs) / 1000 }] : [])
    },
    mapPanelAnchorStyle() {
      return {
        left: this.isCollapsed ? '0' : '23rem',
        width: this.isCollapsed ? '100%' : 'calc(100% - 23rem)'
      }
    },
    /** 播放条隐藏时贴底，保证整屏截取到底部区域 */
    captureFloatingBottom() {
      if (this.hidePlaybackForCapture) return '16px'
      return this.isExpandedNum == 3 ? '107px' : '367px'
    },
    fallbackPlateFromData() {
      const first = this.runRoute && this.runRoute[0];
      return first ? String(first.vclN || first.vno || '').trim() : '';
    },
    // 获取车牌号（无覆盖时用于导出等）
    licensePlate() {
      const fromQuery = this.plateFromQuery != null ? String(this.plateFromQuery).trim() : ''
      const fromApi = this.plateFromApi != null ? String(this.plateFromApi).trim() : ''
      return fromQuery || fromApi || this.fallbackPlateFromData
    },
    /** 行程条/复制/定位等展示用的车牌：与左侧「是否查询」一致 */
    plateForTripHeader() {
      return this.licensePlate
    },
    isConsigMode() {
      return this.tripHeaderOverride != null && String(this.tripHeaderOverride).trim() !== ''
    },
    tripInfoHeaderDisplay() {
      const o = this.tripHeaderOverride != null ? String(this.tripHeaderOverride).trim() : ''
      if (o) return `运单号：${o}`
      return this.plateForTripHeader || '—'
    },
    /** 复制行程文案时的第一行字段名 */
    tripInfoCopyIdLabel() {
      const o = this.tripHeaderOverride != null ? String(this.tripHeaderOverride).trim() : ''
      return o ? '运单号' : '车牌号'
    },
    /** 定位到地图时的主展示编号（与头部一致） */
    mapLocatePrimaryId() {
      const o = this.tripHeaderOverride != null ? String(this.tripHeaderOverride).trim() : ''
      if (o) return o
      return this.plateForTripHeader || ''
    },
    // 处理轨迹数据
    processedTrackData() {
      if (!this.runRoute || this.runRoute.length === 0) {
        return this.trackData;
      }

      return this.runRoute.map((item, index) => {
        const [lonGcj02, latGcj02] = lonLatToGcjLikeTransport(item.lon, item.lat);
        const coordKey = `${lonGcj02.toFixed(6)},${latGcj02.toFixed(6)}`;

        // 格式化 GPS 时间
        let time = '';
        if (item.gtm) {
          // 格式: "yyyymmdd/hhmmss" -> "yyyy-MM-dd hh:mm:ss"
          const datePart = item.gtm.substring(0, 8);
          const timePart = item.gtm.substring(9);
          if (datePart && timePart) {
            const year = datePart.substring(0, 4);
            const month = datePart.substring(4, 6);
            const day = datePart.substring(6, 8);
            const hour = timePart.substring(0, 2);
            const minute = timePart.substring(2, 4);
            const second = timePart.substring(4, 6);
            time = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
          }
        }

        const spdNum = this.qualityMode ? (item.spd != null && Number.isFinite(Number(item.spd)) && Number(item.spd) >= 0 ? Number(item.spd) : null) : parseRunRouteSpdKm(item)
        const hgtRaw = item.hgt
        const hgt =
          hgtRaw != null && hgtRaw !== '' && Number.isFinite(Number(hgtRaw)) ? Number(hgtRaw) : 0
        let agl =
          item.agl != null && item.agl !== '' && Number.isFinite(Number(item.agl))
            ? Math.round(Number(item.agl))
            : null
        if (agl == null) {
          agl = computeTrackRowHeadingDeg(this.runRoute, index)
        }
        const aglCardinal = directionToCardinal8(agl)
        // 构建轨迹数据
        const trackItem = {
          pointKey: item.pointKey,
          rawSpeed: this.qualityMode ? item.rawSpeed : null,
          quality: this.qualityMode ? item.quality || [] : [],
          pointIndex: index,
          wgsLongitude: this.qualityMode ? item.wgsLongitude : null,
          wgsLatitude: this.qualityMode ? item.wgsLatitude : null,
          qualityText: this.qualityMode ? (item.quality || []).map(value => ({ UNKNOWN_SPEED: '速度未知', INVALID_SPEED: '速度非法', OVERSPEED: '超速', GAP_BEFORE: '前段缺报' }[value] || value)).join('、') : '',
          waybillNo: item.waybillNo,
          segmentKey: item.segmentKey,
          time: time,
          timeMs: this.qualityMode ? item.locationTime : parseGtmToMs(item.gtm),
          location: (this.qualityMode && item.address) || this.locationCache[coordKey] || '鼠标移上获取位置...', // 从缓存中获取位置信息
          coordinate: `${lonGcj02.toFixed(6)}, ${latGcj02.toFixed(6)}`,
          speed: this.qualityMode && spdNum == null ? (item.rawSpeed ? `非法(${item.rawSpeed})` : '未知') : `${spdNum}km/h`,
          spdNum,
          hgt,
          roadLimit: item.mspd != null ? item.mspd : item.maxSpd,
          lon: lonGcj02,
          lat: latGcj02,
          mil: item.mil != null ? item.mil : null,
          agl: aglCardinal
        };

        return trackItem;
      });
    },
    // 处理停靠点数据
    processedParkingData() {
      // 如果有通过 props 传递的 parkingData，使用它
      if (this.parkingData && this.parkingData.length > 0) {
        return this.parkingData.map(item => {
          const [lonGcj02, latGcj02] = lonLatToGcjLikeTransport(item.lon, item.lat);
          const coordKey = `${lonGcj02.toFixed(6)},${latGcj02.toFixed(6)}`;

          // 构建停靠点数据
          const presetLoc =
            item.location != null && String(item.location).trim() !== ''
              ? String(item.location).trim()
              : '';
          const parkingItem = {
            ...item,
            lon: lonGcj02,
            lat: latGcj02,
            // 历史轨迹插件接口已带 parkAdr 时优先展示；运输规划页仍为空串则走悬停逆地理
            location: (this.qualityMode && presetLoc) || this.locationCache[coordKey] || presetLoc || '鼠标移上获取位置...'
          };

          return parkingItem;
        });
      }
      // 如果没有 parkingData，返回默认数据
      return [];
    },

    // 停靠点当前页数据
    currentParkingData() {
      const start = (this.parkingPageNum - 1) * this.parkingPageSize;
      const end = start + this.parkingPageSize;
      return this.rangeFilteredParkingData.slice(start, end);
    },
    // 轨迹当前页数据
    currentTrackData() {
      const start = (this.trackPageNum - 1) * this.trackPageSize;
      const end = start + this.trackPageSize;
      return this.rangeFilteredTrackData.slice(start, end);
    },
    // 行程开始信息
    tripStartInfo() {
      const trackData = this.rangeFilteredTrackData;
      const raw = trackData && trackData.length > 0 ? trackData[0] : null
      if (!raw) return null
      const o = this.displayOverride && this.displayOverride.start ? this.displayOverride.start : null
      if (!o) return raw
      const ovLonLatOk =
        o.lon != null &&
        o.lat != null &&
        Number.isFinite(Number(o.lon)) &&
        Number.isFinite(Number(o.lat))
      return {
        ...raw,
        lon: ovLonLatOk ? Number(o.lon) : raw.lon,
        lat: ovLonLatOk ? Number(o.lat) : raw.lat,
        location: o.location != null && String(o.location).trim() !== '' ? String(o.location).trim() : raw.location,
        time: o.time != null && String(o.time).trim() !== '' ? String(o.time).trim() : raw.time
      }
    },
    // 行程结束信息
    tripEndInfo() {
      const trackData = this.rangeFilteredTrackData;
      const raw = trackData && trackData.length > 0 ? trackData[trackData.length - 1] : null
      if (!raw) return null
      const o = this.displayOverride && this.displayOverride.end ? this.displayOverride.end : null
      if (!o) return raw
      const ovLonLatOk =
        o.lon != null &&
        o.lat != null &&
        Number.isFinite(Number(o.lon)) &&
        Number.isFinite(Number(o.lat))
      return {
        ...raw,
        lon: ovLonLatOk ? Number(o.lon) : raw.lon,
        lat: ovLonLatOk ? Number(o.lat) : raw.lat,
        location: o.location != null && String(o.location).trim() !== '' ? String(o.location).trim() : raw.location,
        time: o.time != null && String(o.time).trim() !== '' ? String(o.time).trim() : raw.time
      }
    },
    tripStartCoordinateDisplay() {
      const point = this.tripStartInfo
      const lon = point ? Number(point.lon) : NaN
      const lat = point ? Number(point.lat) : NaN
      return {
        lon: Number.isFinite(lon) ? lon.toFixed(6) : '0',
        lat: Number.isFinite(lat) ? lat.toFixed(6) : '0'
      }
    },
    tripEndCoordinateDisplay() {
      const point = this.tripEndInfo
      const lon = point ? Number(point.lon) : NaN
      const lat = point ? Number(point.lat) : NaN
      return {
        lon: Number.isFinite(lon) ? lon.toFixed(6) : '0',
        lat: Number.isFinite(lat) ? lat.toFixed(6) : '0'
      }
    },
    /** 与地图起终点一致：轨迹首点原始坐标（不受 displayOverride 经纬度影响） */
    tripMapEndpointStart() {
      const tr = this.processedTrackData
      return tr && tr.length ? tr[0] : null
    },
    /** 与地图起终点一致：轨迹尾点原始坐标 */
    tripMapEndpointEnd() {
      const tr = this.processedTrackData
      return tr && tr.length ? tr[tr.length - 1] : null
    },
    /** 行程条地址：取轨迹真实起终点地址，不受装卸货地覆盖影响 */
    tripStartLocationDisplay() {
      const override = this.displayOverride && this.displayOverride.start;
      if (override && override.location) return String(override.location);
      const visible = this.tripStartInfo;
      if (visible && isValidResolvedAddress(visible.location)) return String(visible.location);
      const g = getGlobalCoordAddressCache()
      const cache = this.locationCache
      const p = this.tripMapEndpointStart
      if (!p || p.lon == null || p.lat == null) return '暂无数据'
      const nlo = Number(p.lon)
      const nla = Number(p.lat)
      if (!Number.isFinite(nlo) || !Number.isFinite(nla)) return '暂无数据'
      const key = `${nlo.toFixed(6)},${nla.toFixed(6)}`
      const fromCache = cache[key] ? String(cache[key]).trim() : ''
      if (fromCache && isValidResolvedAddress(fromCache)) return fromCache
      const gv = g.get(key)
      if (gv != null) {
        const ts = String(gv).trim()
        if (ts && isValidResolvedAddress(ts)) return ts
      }
      return '获取地址中...'
    },
    tripEndLocationDisplay() {
      const override = this.displayOverride && this.displayOverride.end;
      if (override && override.location) return String(override.location);
      const visible = this.tripEndInfo;
      if (visible && isValidResolvedAddress(visible.location)) return String(visible.location);
      const g = getGlobalCoordAddressCache()
      const cache = this.locationCache
      const p = this.tripMapEndpointEnd
      if (!p || p.lon == null || p.lat == null) return '暂无数据'
      const nlo = Number(p.lon)
      const nla = Number(p.lat)
      if (!Number.isFinite(nlo) || !Number.isFinite(nla)) return '暂无数据'
      const key = `${nlo.toFixed(6)},${nla.toFixed(6)}`
      const fromCache = cache[key] ? String(cache[key]).trim() : ''
      if (fromCache && isValidResolvedAddress(fromCache)) return fromCache
      const gv = g.get(key)
      if (gv != null) {
        const ts = String(gv).trim()
        if (ts && isValidResolvedAddress(ts)) return ts
      }
      return '获取地址中...'
    },
    /** 轨迹可播放总时长（秒）：优先用首尾 gtm 时间差，否则退化为「点数-1」与旧逻辑一致 */
    trackPlaybackTotalSeconds() {
      const pts = this.processedTrackData;
      if (!pts || pts.length < 2) return 0;
      const all = pts.every((p) => p.timeMs != null);
      if (all) {
        const spanSec = (pts[pts.length - 1].timeMs - pts[0].timeMs) / 1000;
        if (spanSec > 1e-3) return spanSec;
      }
      return Math.max(pts.length - 1, 0);
    },
    /** 按播放进度与总里程估算已行驶距离（与进度条、时间联动） */
    playedDistanceStr() {
      const total = this.trackPlaybackTotalSeconds;
      if (total <= 0 || !this.displayTripSummary || !this.displayTripSummary.distance) return '0km';
      const ratio = Math.min(1, Math.max(0, this.playElapsedSeconds / total));
      const m = String(this.displayTripSummary.distance).match(/([\d.]+)/);
      const totalKm = m ? parseFloat(m[1]) : 0;
      return `${(totalKm * ratio).toFixed(2)}km`;
    },
    /** 速度曲线：时间 + 速度（km/h） */
    speedChartPoints() {
      if (this.qualityMode) return this.rangeFilteredTrackData.map(point => ({ ...point, speed: point.spdNum, trackIndex: this.processedTrackData.findIndex(item => item.pointKey === point.pointKey) }))
      return buildSpeedChartPoints(this.rangeFilteredTrackData)
    },
    fullSpeedChartPoints() {
      if (this.qualityMode) return this.processedTrackData.map((point, index) => ({ ...point, speed: point.spdNum, trackIndex: index }))
      return buildSpeedChartPoints(this.processedTrackData)
    }
  },
  watch: {
    /** 父组件切换为 PathNavigator 后，子组件不应再持有插值车标引用，避免双车标逻辑混乱 */
    pathNavigatorActive(val) {
      if (val) {
        this.vehicleMarker = null;
      }
    },
    // 监听播放速度变化：仅重建定时器，避免暂停再播的顿挫
    playbackSpeed() {
      if (this.pathNavigatorActive) {
        this.$emit('path-nav-control', { type: 'speed', speedMult: parseInt(this.playbackSpeed, 10) || 1 })
        return
      }
      if (this.isPlaying) {
        this.schedulePlayInterval();
      }
    },
    // 监听 runRoute 变化：重置播放并与新轨迹对齐
    runRoute: {
      handler(newVal, oldVal) {
        if (this.runRoutePlaybackSignature(newVal) === this.runRoutePlaybackSignature(oldVal)) return;
        this.resetTrajectoryPlayback();
        this.tripEditDialogVisible = false;
        this.exportDialogVisible = false;
        if (newVal && newVal.length) {
          this.showTripInfo = true;
          this.resolveTripStartEndLocation();
          this.resolveCurrentPageLocation();
          this.scheduleTripAddressHydrate();
        } else {
          this.showTripInfo = false;
          this.clearTripAddressHydrate();
        }
      },
      deep: true
    },
    // 监听 parkingData 变化，当有新数据时解析当前页
    parkingDataIdentity: { handler() { this.parkingPageNum = 1; this.resolveCurrentPageLocation(); } },
    showTripInfo(val) {
      if (val) this.scheduleTripAddressHydrate();
      else this.clearTripAddressHydrate();
    },
    // 监听分页变化，解析当前页数据
    parkingPageNum() {
      this.resolveCurrentPageLocation();
    },
    parkingPageSize() {
      this.resolveCurrentPageLocation();
    },
    trackPageNum() {
      this.resolveCurrentPageLocation();
    },
    trackPageSize() {
      this.resolveCurrentPageLocation();
    }
  },
  created() { if (this.qualityMode) { this.showTripInfo = this.runRoute.length > 0; this.syncTotalTime(); } },
  beforeDestroy() {
    document.removeEventListener('click', this._speedMenuDocHandler);
    if (this.playInterval) {
      clearInterval(this.playInterval);
      this.playInterval = null;
    }
    this.clearTripAddressHydrate();
    if (this.tripEditMapInstance) {
      try {
        this.tripEditMapInstance.destroy()
      } catch (e) {
        /* ignore */
      }
      this.tripEditMapInstance = null
    }
  },
  methods: {
    runRoutePlaybackSignature(route) {
      if (!Array.isArray(route) || !route.length) return '';
      return route.map(item => `${this.qualityMode ? item.pointKey || '' : ''}|${item.gtm || ''}|${item.lon}|${item.lat}`).join(';');
    },
    parseCoordText(coordText) {
      if (coordText == null || String(coordText).trim() === '') return null
      const parts = String(coordText).trim().split(/[,，\s]+/).map((x) => Number(x))
      if (parts.length < 2 || !Number.isFinite(parts[0]) || !Number.isFinite(parts[1])) return null
      return [parts[0], parts[1]]
    },
    formatCoordText(lon, lat) {
      const nlon = Number(lon)
      const nlat = Number(lat)
      if (!Number.isFinite(nlon) || !Number.isFinite(nlat)) return ''
      return `${nlon.toFixed(6)},${nlat.toFixed(6)}`
    },
    serializeTripEditTimeRange(range) {
      if (!Array.isArray(range) || range.length < 2) return JSON.stringify(['', ''])
      return JSON.stringify([
        String(range[0] != null ? range[0] : '').trim(),
        String(range[1] != null ? range[1] : '').trim()
      ])
    },
    captureTripEditOpenSnapshot() {
      this.tripEditOpenSnapshot = {
        timeRange: this.serializeTripEditTimeRange(this.tripEditForm.timeRange),
        startCoord: String(this.tripEditForm.startCoord || '').trim(),
        endCoord: String(this.tripEditForm.endCoord || '').trim(),
        startAddressDetail: String(this.tripEditForm.startAddressDetail || '').trim(),
        endAddressDetail: String(this.tripEditForm.endAddressDetail || '').trim()
      }
    },
    pickTripEditAddressForForm(info, displayedAddress) {
      const candidates = [displayedAddress, info && info.location]
      for (const candidate of candidates) {
        const value = candidate != null ? String(candidate).trim() : ''
        if (value && this.isValidResolvedAddress(value) && !value.includes('鼠标移上')) return value
      }
      return ''
    },
    buildTripEditFormFromTrip() {
      const start = this.tripStartInfo
      const end = this.tripEndInfo
      const startCoord = start ? this.formatCoordText(start.lon, start.lat) : ''
      const endCoord = end ? this.formatCoordText(end.lon, end.lat) : ''
      const startTime = start && start.time != null ? String(start.time).trim() : ''
      const endTime = end && end.time != null ? String(end.time).trim() : ''
      return {
        timeRange: startTime || endTime ? [startTime, endTime] : null,
        startCoord,
        endCoord,
        startAddressDetail: this.pickTripEditAddressForForm(start, this.tripStartLocationDisplay),
        endAddressDetail: this.pickTripEditAddressForForm(end, this.tripEndLocationDisplay)
      }
    },
    resolveTripOverrideLocation(addressChanged, addressFromForm, snapshotAddress, fallbackLocation) {
      if (addressChanged) return addressFromForm != null ? String(addressFromForm).trim() : ''
      const snapshot = snapshotAddress != null ? String(snapshotAddress).trim() : ''
      if (snapshot) return snapshot
      return fallbackLocation != null ? String(fallbackLocation).trim() : ''
    },
    async ensureTripEditMapLoaded() {
      if (this.tripEditMapInstance) return
      if (this.tripEditMapInitPromise) {
        await this.tripEditMapInitPromise
        return
      }
      this.tripEditMapInitPromise = (async () => {
        await this.$nextTick()
        const container = this.$refs.tripEditMapEl
        if (!container) throw new Error('地图容器未就绪')
        setAmapSecurityConfig()
        await loadAmapSDK(['AMap.Geocoder', 'AMap.AutoComplete'])
        const center = this.parseCoordText(this.tripEditForm.startCoord) || [116.404, 39.915]
        this.tripEditMapInstance = new AMap.Map(container, { zoom: 11, center, resizeEnable: true })
        this.tripEditMapInstance.on('click', (event) => {
          const lon = event && event.lnglat ? event.lnglat.getLng() : NaN
          const lat = event && event.lnglat ? event.lnglat.getLat() : NaN
          if (!Number.isFinite(lon) || !Number.isFinite(lat)) return
          const coordText = this.formatCoordText(lon, lat)
          if (this.tripEditMapTarget === 'end') this.tripEditForm.endCoord = coordText
          else this.tripEditForm.startCoord = coordText
          this.tripEditMapInstance.clearMap()
          new AMap.Marker({ position: [lon, lat], map: this.tripEditMapInstance })
        })
      })()
      try {
        await this.tripEditMapInitPromise
      } finally {
        this.tripEditMapInitPromise = null
      }
    },
    async openTripEditMapDialog(target) {
      this.tripEditMapTarget = target === 'end' ? 'end' : 'start'
      this.tripEditMapDialogVisible = true
      await this.$nextTick()
      try {
        await this.ensureTripEditMapLoaded()
        const coord = this.parseCoordText(
          this.tripEditMapTarget === 'end' ? this.tripEditForm.endCoord : this.tripEditForm.startCoord
        )
        if (coord) {
          this.tripEditMapInstance.setZoomAndCenter(15, coord, true)
          this.tripEditMapInstance.clearMap()
          new AMap.Marker({ position: coord, map: this.tripEditMapInstance })
        }
        this.tripEditMapInstance.resize()
      } catch (e) {
        this.$message.warning('地图加载失败，请重试')
      }
    },
    onTripEditMapDialogClose() {
      if (this.tripEditMapInstance) this.tripEditMapInstance.clearMap()
    },
    queryTripEditSearchAsync(queryString, callback) {
      if (!queryString || !window.AMap) {
        callback([])
        return
      }
      AMap.plugin('AMap.AutoComplete', () => this.performTripEditSearch(queryString, callback))
    },
    performTripEditSearch(queryString, callback) {
      const auto = new AMap.AutoComplete({ city: '全国', citylimit: false })
      auto.search(queryString, (status, result) => {
        if (status !== 'complete' || !result || result.info !== 'OK' || !result.tips) {
          callback([])
          return
        }
        callback(result.tips.filter((tip) => tip && tip.location).map((tip) => ({
          value: tip.name,
          address: `${tip.district || ''}${tip.address || ''}`,
          location: tip.location
        })).slice(0, 10))
      })
    },
    handleTripEditMapSelect(item) {
      this.tripEditMapSearchText = item && item.value ? item.value : ''
      if (!item || !item.location || !this.tripEditMapInstance) return
      const lng = typeof item.location.getLng === 'function' ? item.location.getLng() : Number(item.location.lng)
      const lat = typeof item.location.getLat === 'function' ? item.location.getLat() : Number(item.location.lat)
      if (!Number.isFinite(lng) || !Number.isFinite(lat)) return
      this.tripEditMapInstance.setZoomAndCenter(15, [lng, lat], true)
      this.tripEditMapInstance.clearMap()
      new AMap.Marker({ position: [lng, lat], title: item.value || '', map: this.tripEditMapInstance })
      const coordText = this.formatCoordText(lng, lat)
      if (this.tripEditMapTarget === 'end') this.tripEditForm.endCoord = coordText
      else this.tripEditForm.startCoord = coordText
    },
    searchTripEditMapLocation() {
      if (!this.tripEditMapSearchText || !window.AMap || !this.tripEditMapInstance) return
      const geocoder = new AMap.Geocoder({})
      geocoder.getLocation(this.tripEditMapSearchText, (status, result) => {
        if (status !== 'complete' || !result || !result.geocodes || !result.geocodes.length) {
          this.$message.warning('未找到该位置')
          return
        }
        const location = result.geocodes[0].location
        const lng = location.getLng()
        const lat = location.getLat()
        this.tripEditMapInstance.setZoomAndCenter(15, [lng, lat], true)
        this.tripEditMapInstance.clearMap()
        new AMap.Marker({ position: [lng, lat], title: this.tripEditMapSearchText, map: this.tripEditMapInstance })
        const coordText = this.formatCoordText(lng, lat)
        if (this.tripEditMapTarget === 'end') this.tripEditForm.endCoord = coordText
        else this.tripEditForm.startCoord = coordText
      })
    },
    openTripEditDialog() {
      if (!this.processedTrackData || !this.processedTrackData.length) {
        this.$message.warning('暂无轨迹数据，无法修正地址')
        return
      }
      this.tripEditForm = this.buildTripEditFormFromTrip()
      this.tripEditDialogVisible = true
      this.$nextTick(() => {
        const form = this.$refs.tripEditFormRef
        if (form && typeof form.clearValidate === 'function') form.clearValidate()
        this.captureTripEditOpenSnapshot()
      })
    },
    onTripEditDialogClose() {},
    confirmTripEdit() {
      const snapshot = this.tripEditOpenSnapshot || {}
      const range = this.tripEditForm.timeRange
      const timeUnchanged = this.serializeTripEditTimeRange(range) ===
        (snapshot.timeRange || this.serializeTripEditTimeRange(null))
      const startFallback = this.tripStartInfo || {}
      const endFallback = this.tripEndInfo || {}
      const startCoord = this.parseCoordText(this.tripEditForm.startCoord)
      const endCoord = this.parseCoordText(this.tripEditForm.endCoord)
      const startLon = startCoord ? startCoord[0] : Number(startFallback.lon)
      const startLat = startCoord ? startCoord[1] : Number(startFallback.lat)
      const endLon = endCoord ? endCoord[0] : Number(endFallback.lon)
      const endLat = endCoord ? endCoord[1] : Number(endFallback.lat)
      const values = Array.isArray(range) && range.length >= 2 ? range : []
      const startTime = timeUnchanged ? String(startFallback.time || '').trim() : String(values[0] || '').trim()
      const endTime = timeUnchanged ? String(endFallback.time || '').trim() : String(values[1] || '').trim()
      const startInput = String(this.tripEditForm.startAddressDetail || '').trim()
      const endInput = String(this.tripEditForm.endAddressDetail || '').trim()
      const startAddressChanged = startInput !== String(snapshot.startAddressDetail || '').trim()
      const endAddressChanged = endInput !== String(snapshot.endAddressDetail || '').trim()
      const startLocation = this.resolveTripOverrideLocation(
        startAddressChanged,
        startInput,
        snapshot.startAddressDetail,
        startFallback.location
      )
      const endLocation = this.resolveTripOverrideLocation(
        endAddressChanged,
        endInput,
        snapshot.endAddressDetail,
        endFallback.location
      )
      this.$emit('update-display-override', {
        start: {
          time: startTime,
          lon: Number.isFinite(startLon) ? startLon : null,
          lat: Number.isFinite(startLat) ? startLat : null,
          location: startLocation
        },
        end: {
          time: endTime,
          lon: Number.isFinite(endLon) ? endLon : null,
          lat: Number.isFinite(endLat) ? endLat : null,
          location: endLocation
        }
      })
      this.tripEditDialogVisible = false
    },
    isValidResolvedAddress(address) {
      return isValidResolvedAddress(address)
    },
    
    
    
    
    
    
    
    

    /** 仅轨迹首尾 key，与地图逆地理一致（不把 override 坐标灌进行程卡） */
    collectTripGeocodeCacheKeys() {
      const keys = [];
      const pushKey = (lo, la) => {
        if (lo == null || la == null) return;
        const nlo = Number(lo);
        const nla = Number(la);
        if (!Number.isFinite(nlo) || !Number.isFinite(nla)) return;
        const k = `${nlo.toFixed(6)},${nla.toFixed(6)}`;
        if (keys.indexOf(k) === -1) keys.push(k);
      };
      const tr = this.processedTrackData;
      if (tr && tr.length) {
        pushKey(tr[0].lon, tr[0].lat);
        pushKey(tr[tr.length - 1].lon, tr[tr.length - 1].lat);
      }
      return keys;
    },
    /** 地图等组件已写入全局坐标→地址缓存时，同步到本组件 locationCache（触发行程卡更新） */
    hydrateTripAddressesFromGlobalCache() {
      const track = this.processedTrackData;
      if (!track || !track.length) return;
      const g = getGlobalCoordAddressCache();
      const keys = this.collectTripGeocodeCacheKeys();
      let changed = false;
      keys.forEach((key) => {
        if (!key) return;
        const cur = this.locationCache[key];
        if (isValidResolvedAddress(cur)) return;
        const v = g.get(key);
        if (isValidResolvedAddress(v)) {
          this.$set(this.locationCache, key, String(v).trim());
          changed = true;
        }
      });
      if (changed) this.$forceUpdate();
    },
    scheduleTripAddressHydrate() {
      this.clearTripAddressHydrate();
      if (!this.runRoute || !this.runRoute.length || !this.showTripInfo) return;
      let n = 0;
      this.tripAddrHydrateTimer = setInterval(() => {
        n += 1;
        this.hydrateTripAddressesFromGlobalCache();
        if (n >= 35 || !this.showTripInfo || !this.runRoute || !this.runRoute.length) {
          this.clearTripAddressHydrate();
        }
      }, 350);
    },
    clearTripAddressHydrate() {
      if (this.tripAddrHydrateTimer) {
        clearInterval(this.tripAddrHydrateTimer);
        this.tripAddrHydrateTimer = null;
      }
    },
    formatTrackDirectionCell(row, column, cellValue) {
      return directionToCardinal8(cellValue)
    },
    _speedMenuDocHandler(e) {
      if (!this.speedMenuOpen) return;
      const root = this.$refs.speedPicker;
      if (root && !root.contains(e.target)) {
        this.speedMenuOpen = false;
        document.removeEventListener('click', this._speedMenuDocHandler);
      }
    },
    toggleSpeedMenu(e) {
      if (e) e.stopPropagation();
      const willOpen = !this.speedMenuOpen;
      this.speedMenuOpen = willOpen;
      document.removeEventListener('click', this._speedMenuDocHandler);
      if (willOpen) {
        this.$nextTick(() => {
          setTimeout(() => {
            document.addEventListener('click', this._speedMenuDocHandler);
          }, 0);
        });
      }
    },
    selectPlaybackSpeed(val) {
      this.playbackSpeed = String(val);
      this.speedMenuOpen = false;
      document.removeEventListener('click', this._speedMenuDocHandler);
    },
    /** 仅停定时器，不刷新车标（供 reset 时避免「先创建再被 destroy 掉」） */
    stopPlaybackTimer() {
      this.isPlaying = false;
      if (this.playInterval) {
        clearInterval(this.playInterval);
        this.playInterval = null;
      }
    },
    destroyVehicleMarker() {
      // PathNavigator 下车标由父组件维护；此处只清掉子组件里可能残留的引用，避免与父级车标叠两层
      if (this.pathNavigatorActive) {
        this.vehicleMarker = null;
        return;
      }
      if (this.vehicleMarker) {
        this.vehicleMarker.setMap(null);
        this.vehicleMarker = null;
      }
    },
    /**
     * 地图点击轨迹数据点：车标跳到该点预览，播放进度/进度条不变；若正在播放则暂停
     */
    seekPlaybackToRunRouteIndex(index) {
      this.previewTrackPointAtIndex(index);
    },
    previewTrackPointAtIndex(index) {
      const pts = this.processedTrackData;
      if (!pts.length || index < 0 || index >= pts.length) return;
      const p = pts[index];
      this.previewTrackPointAtPosition(p.lon, p.lat, p.bearing, index);
    },
    previewTrackPointAtPosition(lon, lat, bearing, pointIndex) {
      if (this.pathNavigatorActive) return;
      const wasPlaying = this.isPlaying;
      if (wasPlaying) {
        this.pauseTrack();
      }
      const pts = this.processedTrackData;
      let idx = pointIndex;
      if (idx == null && pts.length) {
        let best = 0;
        let bestD2 = Infinity;
        const px = Number(lon);
        const py = Number(lat);
        for (let i = 0; i < pts.length; i++) {
          const dx = Number(pts[i].lon) - px;
          const dy = Number(pts[i].lat) - py;
          const d2 = dx * dx + dy * dy;
          if (d2 < bestD2) {
            bestD2 = d2;
            best = i;
          }
        }
        idx = best;
      }
      const p = idx != null && pts[idx] ? pts[idx] : null;
      const previewLon = p ? p.lon : Number(lon);
      const previewLat = p ? p.lat : Number(lat);
      const previewBearing = p && p.bearing != null ? p.bearing : bearing;
      if (!Number.isFinite(previewLon) || !Number.isFinite(previewLat)) return;
      this.trackPointPreviewActive = true;
      if (!this.vehicleMarker) {
        this.createVehicleMarker();
      }
      if (this.vehicleMarker) {
        this.vehicleMarker.setPosition([previewLon, previewLat]);
        if (previewBearing != null) {
          this.vehicleMarker.setAngle(previewBearing);
        }
      }
      const total = this.trackPlaybackTotalSeconds;
      const ratio = total > 0 ? Math.min(1, Math.max(0, this.playElapsedSeconds / total)) : 0;
      const meta = p ? {
        displayTime: p.time || '—',
        spdKm: p.spdNum != null ? p.spdNum : 0,
        location: p.location || '—',
        hgt: p.hgt,
        roadLimit: p.roadLimit,
        status: p.status || '—'
      } : this.metaAtPlaybackElapsed(this.playElapsedSeconds);
      this.$emit('playback-progress', {
        ratio,
        playElapsedSeconds: this.playElapsedSeconds,
        totalSeconds: total,
        isPlaying: false,
        lon: previewLon,
        lat: previewLat,
        previewOnly: true,
        ...meta
      });
    },
    clearTrackPointPreview() {
      if (!this.trackPointPreviewActive) return;
      this.trackPointPreviewActive = false;
      this.applyPlaybackPosition();
    },
    currentPathNavSpeedMult() {
      return parseInt(this.playbackSpeed, 10) || 1;
    },
    emitPathNavPlay() {
      this.$emit('path-nav-control', {
        type: 'play',
        speedMult: this.currentPathNavSpeedMult()
      });
    },
    // 拖动过程：只跳转轨迹与进度，不改变 isPlaying（播放/暂停按钮保持原状态）
    onProgressInput(val) {
      if (this.suppressSliderSeek) return;
      const trackData = this.processedTrackData;
      if (!trackData.length) return;
      const dragJustStarted = !this.sliderDragging;
      this.sliderDragging = true;
      if (this.pathNavigatorActive && dragJustStarted && this.isPlaying) {
        // 正在播放时开始拖动：先暂停导航器，避免车标与滑块抢进度
        this.$emit('path-nav-control', { type: 'pause' });
      }
      if (this.pathNavigatorActive) {
        this.seekToProgress(val, { commitNavSeek: false });
      } else {
        this.seekToProgress(val);
      }
    },
    /**
     * 当前播放时刻对应的展示字段（供地图侧信息窗同步）
     */
    metaAtPlaybackElapsed(elapsedSec) {
      const pts = this.processedTrackData;
      const n = pts.length;
      if (n === 0) {
        return {
          displayTime: '—',
          spdKm: 0,
          location: '—',
          coordinate: '—',
          hgt: null,
          status: '—',
          roadLimit: '—'
        };
      }
      const total = this.trackPlaybackTotalSeconds;
      const clamped = Math.max(0, Math.min(elapsedSec, total));
      const allTime = pts.every((p) => p.timeMs != null);
      const t0 = pts[0].timeMs;
      const tEnd = pts[n - 1].timeMs;
      const useTime = allTime && t0 != null && tEnd != null && (tEnd - t0) / 1000 > 1e-3;

      let displayTime = pts[0].time || '—';
      let spdKm = pts[0].spdNum != null ? pts[0].spdNum : 0;
      let location = pts[0].location || '—';
      let hgt = pts[0].hgt;
      let roadLimit = pts[0].roadLimit;

      if (useTime) {
        const T = t0 + clamped * 1000;
        displayTime = this.formatMsToDateTime(T);
        if (T <= t0) {
          spdKm = pts[0].spdNum || 0;
          location = pts[0].location || '—';
          hgt = pts[0].hgt;
          roadLimit = pts[0].roadLimit;
        } else if (T >= tEnd) {
          spdKm = pts[n - 1].spdNum || 0;
          location = pts[n - 1].location || '—';
          hgt = pts[n - 1].hgt;
          roadLimit = pts[n - 1].roadLimit;
        } else {
          for (let i = 0; i < n - 1; i++) {
            const a = pts[i].timeMs;
            const b = pts[i + 1].timeMs;
            if (a <= T && T <= b) {
              const denom = b - a;
              const r = denom === 0 ? 0 : (T - a) / denom;
              const sa = pts[i].spdNum != null ? pts[i].spdNum : 0;
              const sb = pts[i + 1].spdNum != null ? pts[i + 1].spdNum : 0;
              spdKm = sa + r * (sb - sa);
              location = r < 0.5 ? (pts[i].location || '—') : (pts[i + 1].location || '—');
              const ha = pts[i].hgt;
              const hb = pts[i + 1].hgt;
              if (ha != null && hb != null) hgt = ha + r * (hb - ha);
              else hgt = ha != null ? ha : hb;
              const ra = pts[i].roadLimit;
              const rb = pts[i + 1].roadLimit;
              roadLimit = ra != null ? ra : rb;
              break;
            }
          }
        }
      } else if (total > 0) {
        const ratio = clamped / total;
        const f = ratio * (n - 1);
        const i = Math.min(Math.floor(f), n - 2);
        const j = i + 1;
        const localR = f - i;
        const sa = pts[i].spdNum != null ? pts[i].spdNum : 0;
        const sb = pts[j].spdNum != null ? pts[j].spdNum : 0;
        spdKm = sa + localR * (sb - sa);
        displayTime = localR < 0.5 ? (pts[i].time || '—') : (pts[j].time || '—');
        location = localR < 0.5 ? (pts[i].location || '—') : (pts[j].location || '—');
        const ha = pts[i].hgt;
        const hb = pts[j].hgt;
        if (ha != null && hb != null) hgt = ha + localR * (hb - ha);
        else hgt = ha != null ? ha : hb;
        roadLimit = pts[i].roadLimit != null ? pts[i].roadLimit : pts[j].roadLimit;
      }

      const pos = this.interpolatePositionAtElapsed(clamped);
      const coordinate = pos ? `${pos.lon.toFixed(6)}, ${pos.lat.toFixed(6)}` : '—';
      const status = spdKm > 0.5 ? '行驶/ACC开启' : '停车';
      const roadStr =
        roadLimit != null && roadLimit !== '' ? `${roadLimit}km/h` : '—';

      return {
        displayTime,
        spdKm,
        location,
        coordinate,
        hgt,
        status,
        roadLimit: roadStr
      };
    },
    formatMsToDateTime(ms) {
      const d = new Date(ms);
      if (Number.isNaN(d.getTime())) return '—';
      const y = d.getFullYear();
      const mo = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const h = String(d.getHours()).padStart(2, '0');
      const mi = String(d.getMinutes()).padStart(2, '0');
      const s = String(d.getSeconds()).padStart(2, '0');
      return `${y}-${mo}-${day} ${h}:${mi}:${s}`;
    },
    /**
     * 根据已播放秒数（相对起点）插值经纬度；优先按 gtm 时间轴，否则按点索引均匀映射
     */
    interpolatePositionAtElapsed(elapsedSec) {
      const pts = this.processedTrackData;
      const n = pts.length;
      if (n === 0) return null;
      if (n === 1) {
        return { lon: pts[0].lon, lat: pts[0].lat, bearing: 0 };
      }
      const total = this.trackPlaybackTotalSeconds;
      const clamped = Math.max(0, Math.min(elapsedSec, total));
      if (this.qualityMode && pts.some((point, index) => index && point.segmentKey !== pts[index - 1].segmentKey && pts[0].timeMs + clamped * 1000 > pts[index - 1].timeMs && pts[0].timeMs + clamped * 1000 < point.timeMs)) return null;
      const allTime = pts.every((p) => p.timeMs != null);
      const t0 = pts[0].timeMs;
      const tEnd = pts[n - 1].timeMs;
      const useTime = allTime && t0 != null && tEnd != null && (tEnd - t0) / 1000 > 1e-3;

      if (useTime) {
        const T = t0 + clamped * 1000;
        if (T <= t0) {
          return {
            lon: pts[0].lon,
            lat: pts[0].lat,
            bearing: this.calculateBearing(pts[0], pts[1])
          };
        }
        if (T >= tEnd) {
          return {
            lon: pts[n - 1].lon,
            lat: pts[n - 1].lat,
            bearing: this.calculateBearing(pts[n - 2], pts[n - 1])
          };
        }
        for (let i = 0; i < n - 1; i++) {
          const a = pts[i].timeMs;
          const b = pts[i + 1].timeMs;
          if (a <= T && T <= b) {
            const denom = b - a;
            const r = denom === 0 ? 0 : (T - a) / denom;
            const lon = pts[i].lon + r * (pts[i + 1].lon - pts[i].lon);
            const lat = pts[i].lat + r * (pts[i + 1].lat - pts[i].lat);
            const bearing = this.calculateBearing(pts[i], pts[i + 1]);
            return { lon, lat, bearing };
          }
        }
      }
      if (total <= 0) {
        return { lon: pts[0].lon, lat: pts[0].lat, bearing: n > 1 ? this.calculateBearing(pts[0], pts[1]) : 0 };
      }
      const ratio = clamped / total;
      const f = ratio * (n - 1);
      const i = Math.min(Math.floor(f), n - 2);
      const j = i + 1;
      const localR = f - i;
      const lon = pts[i].lon + localR * (pts[j].lon - pts[i].lon);
      const lat = pts[i].lat + localR * (pts[j].lat - pts[i].lat);
      const bearing = this.calculateBearing(pts[i], pts[j]);
      return { lon, lat, bearing };
    },
    // 收缩右侧监控区域
    collapsePanel(num) {
      this.$emit('collapse', num);
    },
    // 停靠点分页大小变化
    handleParkingSizeChange(val) {
      this.parkingPageSize = val;
      this.parkingPageNum = 1;
    },
    // 停靠点当前页变化
    handleParkingCurrentChange(val) {
      this.parkingPageNum = val;
    },
    // 轨迹分页大小变化
    handleTrackSizeChange(val) {
      this.trackPageSize = val;
      this.trackPageNum = 1;
    },
    // 轨迹当前页变化
    handleTrackCurrentChange(val) {
      this.trackPageNum = val;
    },
    // 解析行程开始和结束的位置信息
    resolveTripStartEndLocation() {
      if (this.playbackRangeDragging) return
      const trackData = this.rangeFilteredTrackData;
      if (trackData && trackData.length > 0) {
        // 解析第一条数据的位置
        const startPoint = trackData[0];
        const startCoordKey = `${startPoint.lon.toFixed(6)},${startPoint.lat.toFixed(6)}`;
        if (!this.locationCache[startCoordKey] || !isValidResolvedAddress(this.locationCache[startCoordKey])) {
          this.getLocationByCoord(startPoint.lon, startPoint.lat, startCoordKey);
        }

        // 解析最后一条数据的位置
        const endPoint = trackData[trackData.length - 1];
        const endCoordKey = `${endPoint.lon.toFixed(6)},${endPoint.lat.toFixed(6)}`;
        if (!this.locationCache[endCoordKey] || !isValidResolvedAddress(this.locationCache[endCoordKey])) {
          this.getLocationByCoord(endPoint.lon, endPoint.lat, endCoordKey);
        }
      }
      this.scheduleTripAddressHydrate();
    },
    // 解析当前页数据的位置信息（已废弃，改为按需解析）
    resolveCurrentPageLocation() {
      // 不再一页一页解析，改为鼠标悬停时按需解析
    },
    /** el-table 悬停进入单元格时解析（比 span 上 mouseenter 更可靠） */
    onParkingTableCellEnter(row, column) {
      if (column && column.label === '停车位置') {
        this.resolveParkingLocation(row);
      }
    },
    onTrackTableCellEnter(row, column) {
      if (column && column.label === '位置') {
        this.resolveTrackLocation(row);
      }
    },
    // 解析停靠点位置（鼠标悬停时调用）
    resolveParkingLocation(row) {
      if (!row) return;
      if (this.qualityMode && ['未知位置', '未解析'].includes(row.location)) row.location = '';
      if (row.location && row.location !== '鼠标移上获取位置...') return;

      const lon = row.lon;
      const lat = row.lat;
      if (!lon || !lat) return;

      const coordKey = `${lon.toFixed(6)},${lat.toFixed(6)}`;

      if (this.locationCache[coordKey]) {
        this.$set(row, 'location', this.locationCache[coordKey]);
        return;
      }

      this.getLocationByCoord(lon, lat, coordKey, (address) => {
        this.$set(row, 'location', this.qualityMode && !this.isValidResolvedAddress(address) ? '未解析' : address);
      });
    },
    // 解析轨迹点位置（鼠标悬停时调用）
    resolveTrackLocation(row) {
      if (!row) return;
      if (this.qualityMode && ['未知位置', '未解析'].includes(row.location)) row.location = '';
      if (row.location && row.location !== '鼠标移上获取位置...') return;

      const lon = row.lon;
      const lat = row.lat;
      if (!lon || !lat) return;

      const coordKey = `${lon.toFixed(6)},${lat.toFixed(6)}`;

      if (this.locationCache[coordKey]) {
        this.$set(row, 'location', this.locationCache[coordKey]);
        return;
      }

      this.getLocationByCoord(lon, lat, coordKey, (address) => {
        this.$set(row, 'location', this.qualityMode && !this.isValidResolvedAddress(address) ? '未解析' : address);
      });
    },
    // 根据经纬度获取位置信息（统一：缓存 -> 高德 -> stopaddress）
    getLocationByCoord(lon, lat, coordKey, callback) {
      this.resolveAddressByCoord(lon, lat, coordKey)
        .then((address) => {
          if (callback && typeof callback === 'function') {
            callback(address);
          }
          this.$forceUpdate();
        })
        .catch((e) => {
          console.warn('逆地理编码不可用', e);
        });
    },
    /**
     * 统一地址解析（缓存 -> 高德逆地理 -> stopaddress兜底）。
     * 说明：保留同名方法，供组件内部与历史调用链复用。
     */
    async resolveAddressByCoord(lon, lat, coordKey) {
      const addr = await resolveAddressByCoordUtil(lon, lat, {
        coordKey,
        getLocalCache: (k) => this.locationCache && this.locationCache[k],
        setLocalCache: (k, v) => this.$set(this.locationCache, k, v),
        axiosInstance: request,
        AMap: typeof window !== 'undefined' ? window.AMap : null
      })
      return isValidResolvedAddress(addr) ? String(addr).trim() : ''
    },
    // 关闭行程信息
    closeTripInfo() {
      this.showTripInfo = false;
    },
    // 复制行程信息
    copyTripInfo() {
      if (!this.tripStartInfo || !this.tripEndInfo) return;

      const idVal =
        this.tripHeaderOverride != null && String(this.tripHeaderOverride).trim() !== ''
          ? String(this.tripHeaderOverride).trim()
          : this.plateForTripHeader || ''
      const sMap = this.tripMapEndpointStart
      const eMap = this.tripMapEndpointEnd
      const tripInfo = `${this.tripInfoCopyIdLabel}：${idVal}
总里程：${this.displayTripSummary.distance}    总耗时：${this.displayTripSummary.duration}
开始：${this.tripStartInfo.time}
经度：${sMap ? sMap.lon.toFixed(6) : '0'}    纬度：${sMap ? sMap.lat.toFixed(6) : '0'}
${this.tripStartLocationDisplay}
结束：${this.tripEndInfo.time}
经度：${eMap ? eMap.lon.toFixed(6) : '0'}    纬度：${eMap ? eMap.lat.toFixed(6) : '0'}
${this.tripEndLocationDisplay}`;

      // 创建临时文本区域
      const textarea = document.createElement('textarea');
      textarea.value = tripInfo;
      document.body.appendChild(textarea);
      textarea.select();

      try {
        // 执行复制命令
        document.execCommand('copy');
        this.$message.success('复制成功');
      } catch (err) {
        this.$message.error('复制失败');
      } finally {
        // 清理临时元素
        document.body.removeChild(textarea);
      }
    },
    // 暂停轨迹
    pauseTrack() {
      if (this.pathNavigatorActive) {
        if (this.sliderDragging) {
          this.emitPathNavSeekFromCurrentElapsed();
        }
        this.sliderDragging = false;
        // 先置 isPlaying=false，父组件 pathNavPause 里 syncFromPathNavigatorRatio 发出的进度里才是暂停态
        this.stopPlaybackTimer();
        this.$emit('path-nav-control', { type: 'pause' });
        // 灰/绿线由父组件 pathNavPause → syncFromPathNavigatorRatio(真实车标经纬度) 更新，勿再用时间插值 applyPlaybackPosition 覆盖
        return;
      }
      this.stopPlaybackTimer();
      // 同步一次进度与 isPlaying，便于地图信息窗恢复「位置」等展示
      this.applyPlaybackPosition();
    },
    // 创建车辆标记（位置与朝向与当前 playElapsedSeconds 一致）
    createVehicleMarker() {
      if (this.pathNavigatorActive) return;
      if (!window.AMap || this.vehicleMarker) return;

      const trackData = this.processedTrackData;
      if (!trackData || trackData.length === 0) return;

      const pos = this.interpolatePositionAtElapsed(this.playElapsedSeconds);
      const rotation = pos && pos.bearing != null ? pos.bearing : 0;
      const lon = pos ? pos.lon : trackData[0].lon;
      const lat = pos ? pos.lat : trackData[0].lat;

      this.vehicleMarker = new window.AMap.Marker({
        position: [lon, lat],
        icon: new window.AMap.Icon({
          size: new window.AMap.Size(40, 40),
          image: require('@/assets/icon-08.28381b4.png'),
          imageSize: new window.AMap.Size(40, 40)
        }),
        offset: new window.AMap.Pixel(-20, -20),
        angle: rotation
      });

      this.$emit('add-marker', this.vehicleMarker);
    },
    // 计算两点之间的方位角（角度）
    calculateBearing(point1, point2) {
      const lat1 = point1.lat * Math.PI / 180;
      const lon1 = point1.lon * Math.PI / 180;
      const lat2 = point2.lat * Math.PI / 180;
      const lon2 = point2.lon * Math.PI / 180;

      const y = Math.sin(lon2 - lon1) * Math.cos(lat2);
      const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);
      let bearing = Math.atan2(y, x) * 180 / Math.PI;

      // 转换为0-360度
      if (bearing < 0) {
        bearing += 360;
      }

      // 调整角度，减少90度，确保箭头正确对准行驶方向
      bearing -= 90;
      if (bearing < 0) {
        bearing += 360;
      }

      return bearing;
    },
    // 格式化时间（秒数转时分秒）
    formatTime(seconds) {
      const h = Math.floor(seconds / 3600);
      const m = Math.floor((seconds % 3600) / 60);
      const s = seconds % 60;
      return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    },
    openExportDialog() {
      if (!hasPermission('truck:track') || !hasPermission('truck:export')) return this.$message.warning('没有轨迹导出权限');
      this.exportOptionFull = true;
      this.exportOptionParkingOnly = false;
      this.exportOptionNoAddress = false;
      this.exportDialogVisible = true;
    },
    onExportOptionParkingOnlyChange() {
      if (this.exportOptionParkingOnly) {
        this.exportOptionFull = false;
        this.exportOptionNoAddress = false;
      } else if (!this.exportOptionFull && !this.exportOptionNoAddress) {
        this.exportOptionFull = true;
      }
    },
    onExportOptionFullChange() {
      if (this.exportOptionFull) {
        this.exportOptionParkingOnly = false;
        this.exportOptionNoAddress = false;
      } else if (!this.exportOptionParkingOnly && !this.exportOptionNoAddress) {
        this.exportOptionParkingOnly = true;
      }
    },
    onExportOptionNoAddressChange() {
      if (this.exportOptionNoAddress) {
        this.exportOptionParkingOnly = false;
        this.exportOptionFull = false;
      } else if (!this.exportOptionParkingOnly && !this.exportOptionFull) {
        this.exportOptionFull = true;
      }
    },
    async confirmExportFromDialog() {
      if (!hasPermission('truck:track') || !hasPermission('truck:export')) return this.$message.warning('没有轨迹导出权限');
      if (!this.exportOptionParkingOnly && !this.exportOptionFull && !this.exportOptionNoAddress) return this.$message.warning('请选择一种导出方式');
      if (!this.rangeFilteredTrackData.length) return this.$message.warning('暂无轨迹数据');
      const addressMode = this.exportOptionNoAddress ? 'NONE' : this.exportOptionParkingOnly ? 'PARKING' : 'ALL';
      this.exportDialogVisible = false;
      if (this.independentExportHandler) return this.independentExportHandler({ addressMode, pointKeys: this.rangeFilteredTrackData.map(point => point.pointKey) });
    },
    cancelExportRegeo() {
      this.exportCancelRequested = true
      this.exportRegeoProgressVisible = false
      this.exportRegeoProgressLabel = '已取消导出'
      this.$message.info('已取消导出')
    },
    // 导出数据（调整顺序）；parkingOnly 为 true 时仅对停靠点做逆地理，轨迹明细仍导出但不对轨迹点解析地址
    async runExportData(mode) {
      const addressMode = mode === true || mode === 'parking' ? 'parking' : mode === 'none' ? 'none' : 'full'
      const noAddress = addressMode === 'none'
      try {
        this.exportCancelRequested = false
        this.$message({ type: 'info', message: '正在准备导出数据，请稍候...' });

        // 1. 先捕获地图截图（确保地图已加载）
        const mapImageBase64 = await this.captureMapFromContainer();

        // 2. 再处理坐标和位置数据
        const parkingCoords = [];
        const parkingUniqueCoords = new Set();
        if (!noAddress) {
          this.rangeFilteredParkingData.forEach(item => {
            if (item.lon && item.lat) {
              const coord = `${item.lon},${item.lat}`;
              if (!parkingUniqueCoords.has(coord)) {
                parkingUniqueCoords.add(coord);
                parkingCoords.push(coord);
              }
            }
          });
        }

        const trackCoords = [];
        const trackUniqueCoords = new Set();
        if (addressMode === 'full') {
          this.rangeFilteredTrackData.forEach(item => {
            if (item.lon && item.lat) {
              const coord = `${item.lon},${item.lat}`;
              if (!trackUniqueCoords.has(coord)) {
                trackUniqueCoords.add(coord);
                trackCoords.push(coord);
              }
            }
          });
        }

        const totalSteps = parkingCoords.length + trackCoords.length;
        let done = 0;
        let lastProgressAt = 0;
        const afterEach = async () => {
          if (this.exportCancelRequested) {
            throw new Error('__EXPORT_CANCELLED__')
          }
          done += 1;
          const now = Date.now();
          const force = done === 1 || done >= totalSteps;
          if (!force && now - lastProgressAt < 100) return;
          lastProgressAt = now;
          this.exportRegeoProgress = totalSteps ? Math.round((done / totalSteps) * 100) : 100;
          this.exportRegeoProgressLabel = `正在解析地址 ${done}/${totalSteps}`;
        };

        if (totalSteps > 0) {
          this.exportRegeoProgress = 0;
          this.exportRegeoProgressLabel = `正在解析地址 0/${totalSteps}`;
          this.exportRegeoProgressVisible = true;
          await this.$nextTick();
        }

        let parkingLocationData = {};
        if (parkingCoords.length > 0) {
          parkingLocationData = await this.batchProcessCoords(parkingCoords, afterEach);
        }

        let trackLocationData = {};
        if (addressMode === 'full' && trackCoords.length > 0) {
          trackLocationData = await this.batchProcessCoords(trackCoords, afterEach);
        }

        if (this.exportCancelRequested) {
          throw new Error('__EXPORT_CANCELLED__')
        }

        // 3. 最后生成Excel；轨迹工作表始终导出；parkingOnly 时轨迹「位置」列固定为「未解析」、不做逆地理
        await this.downloadExportFile(parkingLocationData, trackLocationData, mapImageBase64, {
          includeTrackSheet: true,
          addressMode
        });

        this.$message({ type: 'success', message: '导出成功！' });
      } catch (error) {
        if (error && error.message === '__EXPORT_CANCELLED__') {
          // 用户主动取消，不提示失败
        } else {
          console.error('导出失败:', error);
          this.$message.error('导出失败，请重试');
        }
      } finally {
        this.exportRegeoProgressVisible = false;
      }
    },
    // 多并发天地图逆地理（保序）：数量越大并发越高，并优先命中全局坐标缓存
    async batchProcessCoords(coords, onEachResolved) {
      return tiandituDecodeCoordsConcurrent(coords, {
        shouldCancel: () => this.exportCancelRequested,
        onProgress: async () => {
          if (typeof onEachResolved === 'function') {
            await onEachResolved()
          }
        }
      })
    },
    // 兼容旧调用：按 # 分隔的坐标串逐条天地图逆地理
    async getAddressList(coordsStr) {
      const coords = String(coordsStr || '')
        .split('#')
        .map((s) => s.trim())
        .filter(Boolean);
      try {
        const { resultList } = await tiandituDecodeCoordsSequential(coords);
        const successCount = resultList.filter((r) => r.success).length;
        return {
          success: true,
          code: 0,
          msg: '',
          data: {
            resultList,
            successCount,
            failCount: resultList.length - successCount
          }
        };
      } catch (error) {
        console.error('逆地理编码失败:', error);
        return {
          success: false,
          code: -1,
          msg: String(error && error.message ? error.message : error),
          data: {
            resultList: [],
            successCount: 0,
            failCount: coords.length
          }
        };
      }
    },
    // 生成导出内容
    // generateExportContent(locationData) {
    //   let content = '明细';

    //   // 停靠点明细
    //   content += '停靠点明细\n';
    //   content += '================================\n';
    //   content += '序号\t停车时长\t停车开始时间\t停车结束时间\t停车位置\n';

    //   this.currentParkingData.forEach((item, index) => {
    //     let location = item.location || '未知位置';
    //     // 从接口返回的数据中获取地址
    //     if ( locationData && locationData.resultList) {
    //       const result = locationData.resultList.find(r =>
    //         r.lon == item.lon &&
    //         r.lat == item.lat
    //       );
    //       if (result && result.success) {
    //         location = `${result.des}`;
    //       }
    //     }
    //     content += `${index + 1}\t${item.duration}\t${item.startTime}\t${item.endTime}\t${location}\n`;
    //   });

    //   content += '\n';

    //   // 轨迹明细
    //   content += '轨迹明细\n';
    //   content += '================================\n';
    //   content += '时间\t位置\t坐标\t上报里程\t海拔\t速度\n';

    //   this.currentTrackData.forEach(item => {
    //     let location = item.location || '未知位置';

    //     // 从接口返回的数据中获取地址
    //     if (locationData.success && locationData.data && locationData.data.resultList) {
    //       const result = locationData.data.resultList.find(r =>
    //         r.lon === item.lon&&
    //         r.lat=== item.lat
    //       );
    //       if (result && result.success) {
    //         location = `${result.des}`;
    //       }
    //     }

    //     content += `${item.time}\t${location}\t${item.coordinate}\t${item.mil || 0}\t${item.hgt || 0}\t${item.speed}\n`;
    //   });

    //   return content;
    // },
    // 捕获地图截图
    captureMap() { return this.captureMapFromContainer(); },
    // 下载导出文件
    // 下载导出文件（接收mapImageBase64参数）
    /**
     * @param exportOptions.includeTrackSheet 是否包含轨迹明细表（默认 true）
     * @param exportOptions.parkingOnlyRegeo 仅解析停靠点时 true：轨迹「位置」列写「未解析」
     */
    getExportRowLocation(addressMode, item, locationData) {
      if (addressMode === 'none') return '未解析';
      let location = item.location || '未知位置';
      if (locationData && locationData.resultList) {
        const result = locationData.resultList.find(r =>
          r.lon === item.lon &&
          r.lat === item.lat
        );
        if (result && result.success) location = `${result.des}`;
      }
      return location;
    },
    async downloadExportFile(
      parkingLocationData,
      trackLocationData,
      mapImageBase64,
      exportOptions = {}
    ) {
      const includeTrackSheet = exportOptions.includeTrackSheet !== false;
      const addressMode = exportOptions.addressMode === 'none'
        ? 'none'
        : exportOptions.addressMode === 'parking' || exportOptions.parkingOnlyRegeo === true
          ? 'parking'
          : 'full';
      try {
        // ✅ 关键修复：创建 Excel 工作簿实例
        const workbook = new ExcelJS.Workbook();
        workbook.creator = '铁路管理系统';
        workbook.lastModifiedBy = '铁路管理系统';
        workbook.created = new Date();
        workbook.modified = new Date();
        const taskMeta = buildTrajectoryTaskMetadata(this);

        // ========== 1. 停靠点明细工作表 ==========
        const parkingSheet = workbook.addWorksheet('停靠点明细');
        writeTrajectoryTaskInfoBanner(parkingSheet, taskMeta);
        writeTrajectoryDetailTableHeader(parkingSheet, [
          { header: '序号', key: 'index', width: 8 },
          { header: '停车时长', key: 'duration', width: 16 },
          { header: '停车开始时间', key: 'startTime', width: 22 },
          { header: '停车结束时间', key: 'endTime', width: 22 },
          { header: '停车位置', key: 'location', width: 45 }
        ]);

        this.rangeFilteredParkingData.forEach((item, index) => {
          const location = this.getExportRowLocation(addressMode, item, parkingLocationData);
          const row = parkingSheet.addRow({
            index: index + 1,
            duration: item.duration,
            startTime: item.startTime,
            endTime: item.endTime,
            location: location
          });
          row.height = 30;
          row.getCell('A').alignment = { horizontal: 'left', vertical: 'middle' };
        });

        // ========== 2. 轨迹明细工作表（可选）==========
        if (includeTrackSheet) {
          const trackSheet = workbook.addWorksheet('轨迹明细');
          writeTrajectoryTaskInfoBanner(trackSheet, taskMeta);
          writeTrajectoryDetailTableHeader(trackSheet, [
            { header: '时间', key: 'time', width: 22 },
            { header: '位置', key: 'location', width: 80 },
            { header: '坐标', key: 'coordinate', width: 35 },
            { header: '方向', key: 'agl', width: 10 },
            { header: '上报里程', key: 'mil', width: 14 },
            { header: '海拔', key: 'hgt', width: 12 },
            { header: '速度', key: 'speed', width: 12 }
          ]);

          this.rangeFilteredTrackData.forEach(item => {
            let location;
            if (addressMode !== 'full') {
              location = '未解析';
            } else {
              location = this.getExportRowLocation(addressMode, item, trackLocationData);
            }
            const row = trackSheet.addRow({
              time: item.time,
              location: location,
              coordinate: item.coordinate,
              agl: directionToCardinal8(item.agl),
              mil: item.mil || 0,
              hgt: item.hgt != null ? item.hgt : 0,
              speed: item.speed
            });
            row.height = 30;
            row.getCell('C').alignment = { horizontal: 'right', vertical: 'middle' };
            row.getCell('G').alignment = { horizontal: 'right', vertical: 'middle' };
          });
        }

        // ========== 3. 轨迹地图工作表 ==========
        const mapSheet = workbook.addWorksheet('轨迹地图');
        writeTrajectoryTaskInfoBanner(mapSheet, taskMeta);
        const mapTitleRow = mapSheet.addRow(['轨迹地图']);
        mapTitleRow.font = { bold: true, size: 16 };
        mapTitleRow.alignment = { horizontal: 'center' };
        mapSheet.mergeCells(`A${mapTitleRow.number}:F${mapTitleRow.number}`);
        mapSheet.columns.forEach(column => { column.width = 30; });

        // 导出地图尺寸：与 buildAmapStaticMapUrl 的 1200×800 一致，用 ext（像素@96dpi）固定宽高比，避免 tl+br 铺满单元格时被横向拉扁
        const exportMapExtW = 1200;
        const exportMapExtH = 600;
        /** 为悬浮图预留行数，避免「注」与图片重叠（按默认行高约 15pt 估算） */
        const exportMapNoteRowSkip = Math.max(36, Math.ceil(exportMapExtH / 18) + 2);

        if (mapImageBase64) {
          try {
            const mapImageId = workbook.addImage({
              name: 'map_screenshot', // 必须保留name字段
              base64: mapImageBase64,
              extension: 'png'
            });
            mapSheet.addImage(mapImageId, {
              tl: { col: 0, row: mapTitleRow.number },
              ext: { width: exportMapExtW, height: exportMapExtH },
              editAs: 'oneCell'
            });
            for (let i = 0; i < exportMapNoteRowSkip; i++) {
              mapSheet.addRow([]);
            }
            const noteRow = mapSheet.addRow(['注: 地图截图已插入上方']);
            noteRow.alignment = { horizontal: 'center' };
            mapSheet.mergeCells(`A${noteRow.number}:F${noteRow.number}`);
          } catch (error) {
            console.error('插入地图图片失败:', error);
            const failRow = mapSheet.addRow(['地图截图插入失败']);
            failRow.alignment = { horizontal: 'center' };
            mapSheet.mergeCells(`A${failRow.number}:F${failRow.number}`);
          }
        } else {
          const emptyRow = mapSheet.addRow(['未获取到地图截图，请确保地图已完全加载']);
          emptyRow.alignment = { horizontal: 'center' };
          mapSheet.mergeCells(`A${emptyRow.number}:F${emptyRow.number}`);
        }

        // ========== 4. 生成并下载文件 ==========
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(
          new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
          buildTrajectoryExportFileName(this.plateForTripHeader)
        );
      } catch (error) {
        console.error('导出失败:', error);
        this.$message.error('导出失败，请重试');
      }
    },
    /** WebService 静态图：不传 location/zoom，由服务端按 paths 包住整段轨迹 */
    buildAmapStaticMapUrl() {
      if (this.rangeFilteredTrackData.some(point => point.segmentKey !== undefined)) {
        const groups = []
        this.rangeFilteredTrackData.forEach((point, index, points) => {
          if (!index || point.segmentKey !== points[index - 1].segmentKey) groups.push([])
          groups[groups.length - 1].push(point)
        })
        const urls = groups.map(points => buildAmapStaticMapUrlFromTrackPoints(points, { maxPts: 400, size: '1024*1024', scale: 2, stroke: '8,0xFF0000,1,,' })).filter(Boolean)
        if (!urls.length) return null
        const url = new URL(urls[0])
        url.searchParams.set('paths', urls.map(value => new URL(value).searchParams.get('paths')).join('|'))
        return url.toString()
      }
      return buildAmapStaticMapUrlFromTrackPoints(this.rangeFilteredTrackData, {
        maxPts: 400,
        size: '1024*1024',
        scale: 2,
        stroke: '8,0xFF0000,1,,'
      });
    },
    /** fetch 拉取静态图再绘到 canvas，避免 img 跨域导致 canvas 空白 */
    async loadImageUrlAsPngBase64(url) {
      if (!url) return null;
      try {
        const res = await fetch(url, { mode: 'cors', credentials: 'omit' });
        if (!res.ok) return null;
        const blob = await res.blob();
        if (typeof createImageBitmap === 'function') {
          const bitmap = await createImageBitmap(blob);
          try {
            const canvas = document.createElement('canvas');
            canvas.width = bitmap.width;
            canvas.height = bitmap.height;
            const ctx = canvas.getContext('2d');
            ctx.fillStyle = '#e8ecf0';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(bitmap, 0, 0);
            return canvas.toDataURL('image/png').split(',')[1];
          } finally {
            if (bitmap.close) bitmap.close();
          }
        }
        return await this.loadImageBlobViaImg(blob);
      } catch (e) {
        console.warn('静态图拉取/绘制失败', e);
        return null;
      }
    },
    loadImageBlobViaImg(blob) {
      return new Promise((resolve) => {
        const u = URL.createObjectURL(blob);
        const img = new Image();
        img.onload = () => {
          try {
            const canvas = document.createElement('canvas');
            canvas.width = img.naturalWidth || img.width;
            canvas.height = img.naturalHeight || img.height;
            const ctx = canvas.getContext('2d');
            ctx.fillStyle = '#e8ecf0';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0);
            URL.revokeObjectURL(u);
            resolve(canvas.toDataURL('image/png').split(',')[1]);
          } catch (err) {
            URL.revokeObjectURL(u);
            resolve(null);
          }
        };
        img.onerror = () => {
          URL.revokeObjectURL(u);
          resolve(null);
        };
        img.src = u;
      });
    },
    /**
     * 将行程信息面板叠到地图 PNG 上，并裁剪为视口矩形：
     * 从 trip-info 左下角 (left, bottom) 到可视区域右上角 (innerWidth, 0) 所围成的区域。
     */
    async compositeTripInfoOntoMapBase64(mapBase64NoPrefix) {
      if (!mapBase64NoPrefix) return null;
      const tripEl = this.$refs.tripInfoPanel;
      const mapEl = document.getElementById('amap');
      if (!tripEl || !mapEl) return mapBase64NoPrefix;
      const style = window.getComputedStyle(tripEl);
      if (style.display === 'none' || style.visibility === 'hidden' || tripEl.offsetWidth < 2) {
        return mapBase64NoPrefix;
      }
      return new Promise((resolve) => {
        const mapImg = new Image();
        mapImg.onload = async () => {
          try {
            const w = mapImg.naturalWidth || mapImg.width;
            const h = mapImg.naturalHeight || mapImg.height;
            const mapRect = mapEl.getBoundingClientRect();
            const tripRect = tripEl.getBoundingClientRect();
            if (mapRect.width < 1 || mapRect.height < 1) {
              resolve(mapBase64NoPrefix);
              return;
            }
            const vw = window.innerWidth;
            if (tripRect.bottom <= 0 || tripRect.left >= vw) {
              resolve(mapBase64NoPrefix);
              return;
            }
            const sx = w / mapRect.width;
            const sy = h / mapRect.height;
            /** 视口裁剪：左 = trip-info 左缘，上 = 地图顶边；下必须取地图底边，勿用 trip 底边（播放条上方的行程卡底边会裁掉轨迹南端） */
            const R = {
              left: tripRect.left,
              top: mapRect.top,
              right: vw,
              bottom: Math.max(tripRect.bottom, mapRect.bottom)
            };
            const cropW = Math.max(1, Math.round(R.right - R.left));
            const cropH = Math.max(1, Math.round(R.bottom - R.top));
            // 以地图截图的实际像素密度输出，避免合成后再次按 CSS 像素降采样导致发糊
            const outW = Math.max(1, Math.round(cropW * sx));
            const outH = Math.max(1, Math.round(cropH * sy));
            const canvas = document.createElement('canvas');
            canvas.width = outW;
            canvas.height = outH;
            const ctx = canvas.getContext('2d');
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';
            ctx.fillStyle = '#e8ecf0';
            ctx.fillRect(0, 0, outW, outH);
            const ix1 = Math.max(R.left, mapRect.left);
            const ix2 = Math.min(R.right, mapRect.right);
            const iy1 = Math.max(R.top, mapRect.top);
            const iy2 = Math.min(R.bottom, mapRect.bottom);
            if (ix1 < ix2 && iy1 < iy2) {
              const srcX = (ix1 - mapRect.left) * sx;
              const srcY = (iy1 - mapRect.top) * sy;
              const srcW = (ix2 - ix1) * sx;
              const srcH = (iy2 - iy1) * sy;
              const dstX = (ix1 - R.left) * sx;
              const dstY = (iy1 - R.top) * sy;
              const dstW = (ix2 - ix1) * sx;
              const dstH = (iy2 - iy1) * sy;
              ctx.drawImage(mapImg, srcX, srcY, srcW, srcH, dstX, dstY, dstW, dstH);
            }
            const tripCanvas = await html2canvas(tripEl, {
              useCORS: true,
              allowTaint: true,
              scale: Math.min(window.devicePixelRatio || 1, 3),
              backgroundColor: null,
              logging: false,
              width: tripEl.offsetWidth,
              height: tripEl.offsetHeight
            });
            const tx = (tripRect.left - R.left) * sx;
            const ty = (tripRect.top - R.top) * sy;
            const tw = tripRect.width * sx;
            const th = tripRect.height * sy;
            ctx.drawImage(
              tripCanvas,
              0,
              0,
              tripCanvas.width,
              tripCanvas.height,
              tx,
              ty,
              tw,
              th
            );
            resolve(canvas.toDataURL('image/png').split(',')[1]);
          } catch (e) {
            console.warn('行程信息叠加失败', e);
            resolve(mapBase64NoPrefix);
          }
        };
        mapImg.onerror = () => resolve(mapBase64NoPrefix);
        mapImg.src = `data:image/png;base64,${mapBase64NoPrefix}`;
      });
    },
    /**
     * 与「数据导出」中轨迹地图一致：高德静态图 / DOM 截图得到轨迹，再叠加 trip-info（起终点地址等）
     */
    async downloadTripViewportScreenshot(options = {}) {
      if (!hasPermission('truck:track') || !hasPermission('truck:export')) return this.$message.warning('没有轨迹导出权限');
      const actor = authState.user;
      const isCurrent = () => !this._isDestroyed && authState.user === actor;
      let loading;
      try {
        if (!options.skipPrepareLayout) {
          await new Promise((done) => {
            this.$emit('prepare-capture-layout', { isCollapsed: true, isExpandedNum: 3, done });
            setTimeout(done, 2500);
          });
          await this.$nextTick();
        }
        if (!isCurrent()) return;
        const tripEl = this.$refs.tripInfoPanel;
        if (!tripEl) return this.$message.warning('未找到行程信息面板');
        const style = window.getComputedStyle(tripEl);
        if (style.display === 'none' || style.visibility === 'hidden' || tripEl.offsetWidth < 2) return this.$message.warning('请先显示行程信息面板后再截图（含起终点地址）');
        loading = this.$loading({ lock: true, text: '正在生成地图与行程截图…', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.35)' });
        const mapB64 = await this.captureMapFromContainer();
        if (!isCurrent()) return;
        if (!mapB64) return this.$message.error('未获取到地图截图，请确保地图与轨迹已加载');
        const blob = await (await fetch(`data:image/png;base64,${mapB64}`)).blob();
        if (!isCurrent()) return;
        saveAs(blob, `轨迹地图截图_${new Date().toISOString().slice(0, 19).replace(/[-:T]/g, '')}.png`);
        this.$message.success('截图已下载');
      } catch (error) {
        if (isCurrent()) this.$message.error('截图失败，请稍后重试');
      } finally {
        if (loading) loading.close();
        if (!options.skipPrepareLayout && isCurrent()) this.$emit('restore-capture-ui');
      }
    },
    async captureMapDomFallback() {
      const map = window.__AMAP_MAP__ || window.map;
      if (map) {
        try {
          await new Promise((r) => setTimeout(r, 450));
          const shot = new Screenshot(map);
          const dataUrl = await shot.toDataURL('image/png');
          if (dataUrl && dataUrl.length > 2000) {
            return dataUrl.split(',')[1];
          }
        } catch (e) {
          console.warn('@amap/screenshot 失败', e);
        }
      }
      const el = document.getElementById('amap');
      if (!el) return null;
      await new Promise((r) => setTimeout(r, 400));
      try {
        const canvas = await html2canvas(el, {
          useCORS: true,
          allowTaint: true,
          scale: Math.min(window.devicePixelRatio || 1, 3),
          backgroundColor: '#e8ecf0',
          logging: false,
          width: el.clientWidth,
          height: el.clientHeight
        });
        const b64 = canvas.toDataURL('image/png').split(',')[1];
        return b64 && b64.length > 2000 ? b64 : null;
      } catch (e) {
        console.error('html2canvas 失败', e);
        return null;
      }
    },
    async captureMapFromContainer() {
      let mapB64 = null;
      try {
        if (this.rangeFilteredTrackData && this.rangeFilteredTrackData.length >= 2) {
          const staticUrl = this.buildAmapStaticMapUrl();
          if (staticUrl) {
            mapB64 = await this.loadImageUrlAsPngBase64(staticUrl);
          }
        }
      } catch (e) {
        console.warn('高德静态图失败', e);
      }
      const staticOk = mapB64 && mapB64.length > 3000;
      if (!staticOk) {
        const domB64 = await this.captureMapDomFallback();
        if (domB64 && (!mapB64 || domB64.length > (mapB64.length || 0))) {
          mapB64 = domB64;
        }
      }
      if (!mapB64) return null;
      return this.compositeTripInfoOntoMapBase64(mapB64);
    },
    removeUnit1(speed) {
    return speed.split('km/h')[0];
},
    onSpeedCurvePointClick(payload) {
      handleSpeedCurvePointClick(this, payload)
    },
    goToMap(locationData) {
      let speedRaw =
        locationData && locationData.spdNum != null && locationData.spdNum !== ''
          ? locationData.spdNum
          : locationData && locationData.speed != null
            ? locationData.speed
            : 0
      if (this.qualityMode) speedRaw = locationData.spdNum != null && Number.isFinite(Number(locationData.spdNum)) && Number(locationData.spdNum) >= 0 ? Number(locationData.spdNum) : null
      // 向父组件发送事件，请求定位到地图并展示弹窗
      this.$emit('locate-on-map', {
        lon: locationData.lon,
        lat: locationData.lat,
        coordType: 'gcj02',
        location: locationData.location,
        time: locationData.time,
        gpsTime: this.qualityMode ? locationData.timeMs : undefined,
        speed: speedRaw,
        hgt: locationData.hgt != null && locationData.hgt !== '' ? locationData.hgt : (locationData.alt != null ? locationData.alt : null),
        agl: locationData.agl,
        angle: locationData.angle,
        gpsStatus: locationData.gpsStatus,
        pointIndex: locationData.pointIndex,
        plateNumber: this.mapLocatePrimaryId
      });
    },
       formatDate(dateString) {
    // 解析原始日期字符串
    const date = new Date(dateString);

    // 格式化日期
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
},
    // 定位到地图并展示弹窗
    goToMapParking(locationData) {
      const parsedTime = this.formatDate(locationData.endTime)
      const newData = this.processedTrackData.find(item => item.time === parsedTime)
      if (this.qualityMode && !newData) return
      // 向父组件发送事件，请求定位到地图并展示弹窗
      this.$emit('locate-on-map', {
        lon: locationData.lon,
        lat:  locationData.lat,
        coordType: 'gcj02',
        location: locationData.location,
        time: newData.time,
        gpsTime: this.qualityMode ? newData.timeMs : undefined,
        speed: this.removeUnit1(newData.speed),
        hgt: newData.hgt?newData.hgt:0,
        agl: newData.agl,
        angle: locationData.angle,
        gpsStatus: locationData.gpsStatus,
        pointIndex: locationData.pointIndex,
        popupType: 'parking',
        parkingStartTime:this.formatDate(locationData.startTime),
        parkingEndTime: this.formatDate(locationData.endTime),
        parkingDuration: locationData.duration || locationData.parkingDuration,
        plateNumber: this.mapLocatePrimaryId
      });
    }
  },
}
</script>

<style>
/* 进度条时间 tooltip 盖住地图/信息窗时仍锚在滑块上，避免错位叠在弹窗上 */
.trip-player-slider-tooltip {
  z-index: 20050 !important;
}

.el-button {
  font-size: 0.875rem !important;
  padding: 0.5rem!important;
  box-sizing: border-box;
}

.el-tabs__item {
  font-size: 0.875rem !important;
}

.el-table thead th {
  font-size: 0.875rem !important;
  color: #333 !important;
}

.el-table tr td {
  font-size: 0.875rem !important;
}
.el-table .el-table__cell{
  padding: 0.4rem !important;
}
.el-pagination .el-input__inner{
  height: 1.8rem !important;
}
</style>
<style scoped>
@import '@/styles/playback-player.css';

.trip-info-popup {
  position: absolute;
  bottom: 0;
  left: 23rem;
  border-radius: 0.25rem;
  padding: 0.4rem 0.75rem;
  z-index: 9;
  width: calc(100% - 23rem);
  height: 100%;
}

.trip-info {
  width: 21rem;
  position: absolute;
  left: 23rem;
  z-index: 9;
  bottom: 28.3rem;
  margin: 0.4rem 0.75rem 0;
  padding: 0;
  overflow: hidden;
  background: #fff;
  border-radius: 0.75rem;
  box-shadow: 0 0.25rem 1.25rem rgba(15, 40, 80, 0.12), 0 0.0625rem 0.25rem rgba(15, 40, 80, 0.06);
  border: 0.0625rem solid rgba(0, 0, 0, 0.06);
}

.trip-info__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.25rem 0.875rem;
  background: linear-gradient(135deg, #3a7afe 0%, #2b6ae8 100%);
  color: #fff;
}

.trip-info__plate {
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-shadow: 0 0.0625rem 0 rgba(0, 0, 0, 0.08);
}
.trip-info__plate.is-consig {
  font-size: 0.875rem;
  letter-spacing: 0.01em;
}

.trip-info__actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 0.125rem;
}

.trip-info__icon-btn {
  padding: 0.25rem !important;
  min-width: auto !important;
  color: #fff !important;
  font-size: 1.125rem !important;
}

.trip-info__icon-btn:hover,
.trip-info__icon-btn:focus {
  color: #fff !important;
  background: rgba(255, 255, 255, 0.18) !important;
}

.trip-info__icon-btn--close:hover {
  background: rgba(255, 255, 255, 0.22) !important;
}

.trip-info__summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem 1rem;
  padding: 0.3rem 0.875rem;
  font-size: 0.8125rem;
  color: #303133;
  background: #fafbfc;
  border-bottom: 0.0625rem solid #eef0f3;
}

.trip-info__summary-item {
  flex: 1 1 auto;
  min-width: 0;
}

.trip-info__summary-item em {
  font-style: normal;
  font-weight: 600;
  color: #1a1a1a;
}

.trip-info__body {
  padding: 0.75rem 0.875rem 0.875rem;
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
}

.trip-section {
  margin: 0;
  padding: 0.625rem 0.75rem;
  background: #f0f7ff;
  border-radius: 0.5rem;
  border: 0.0625rem solid rgba(64, 158, 255, 0.12);
}

.trip-section__title {
  margin: 0 0 0.5rem;
  color: #303133;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.35;
}

.trip-section__coords {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem 1.25rem;
  margin-bottom: 0.375rem;
  font-size: 0.75rem;
  color: #606266;
}

.trip-section__addr {
  margin: 0;
  font-size: 0.75rem;
  color: #909399;
  line-height: 1.5;
  word-break: break-all;
}

.trip-edit-form .form-row {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
}

.trip-edit-form .form-item {
  flex: 1;
  min-width: 0;
}

.trip-edit-map-wrap {
  width: 100%;
  height: 50vh;
  position: relative;
}

.trip-edit-map {
  width: 100%;
  height: 100%;
}

.trip-edit-map-search {
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 9999;
  padding: 0.5rem;
  background-color: #fff;
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.75rem 0 rgba(0, 0, 0, 0.1);
}

.video-player {
  background-color: #fffc;
  border-radius: 0.25rem;
  padding: 0.3rem 0.5rem;
  box-shadow: 0 0.125rem 0.75rem 0 rgba(0, 0, 0, 0.1);
  border: 0.0625rem solid #dcdfe6;
  margin-top: 0.2rem;
  width: 100%;
  overflow: visible;
}

.time-display {
  font-size: 0.875rem;
  color: #606266;
  min-width: 3.75rem;
  text-align: center;
}

.speed-picker {
  position: relative;
  flex-shrink: 0;
  width: 6.25rem;
  z-index: 3001;
}

.speed-picker__trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  width: 100%;
  height: 2rem;
  padding: 0 0.5rem;
  font-size: 0.8125rem;
  color: #606266;
  background: #fff;
  border: 0.0625rem solid #dcdfe6;
  border-radius: 0.25rem;
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.speed-picker__trigger:hover {
  border-color: #c0c4cc;
}

.speed-picker__trigger.is-open {
  border-color: #409eff;
  box-shadow: 0 0 0 0.0625rem rgba(64, 158, 255, 0.2);
}

.speed-picker__caret {
  font-size: 0.75rem;
  transition: transform 0.2s;
}

.speed-picker__trigger.is-open .speed-picker__caret {
  transform: rotate(180deg);
}

.speed-picker__dropdown {
  position: absolute;
  bottom: calc(100% + 0.5rem);
  left: 50%;
  transform: translateX(-50%);
  min-width: 5.5rem;
  padding: 0.375rem 0;
  background: #fff;
  border-radius: 0.375rem;
  box-shadow: 0 0.25rem 1rem rgba(15, 40, 80, 0.12), 0 0.125rem 0.375rem rgba(15, 40, 80, 0.08);
  border: 0.0625rem solid rgba(0, 0, 0, 0.06);
}

.speed-picker__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.speed-picker__item {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 2.5rem;
  padding: 0.375rem 1rem;
  font-size: 0.8125rem;
  color: #606266;
  cursor: pointer;
  user-select: none;
  transition: background 0.12s, color 0.12s;
}

.speed-picker__item:nth-child(even):not(.is-active) {
  background: rgba(250, 250, 250, 0.95);
}

.speed-picker__item:hover:not(.is-active) {
  background: #f5f7fa;
}

.speed-picker__item.is-active {
  background: #f0f7ff !important;
  color: #409eff;
  font-weight: 600;
}

.speed-picker__arrow {
  position: absolute;
  bottom: -0.375rem;
  left: 50%;
  width: 0;
  height: 0;
  margin-left: -0.375rem;
  border-left: 0.375rem solid transparent;
  border-right: 0.375rem solid transparent;
  border-top: 0.375rem solid #fff;
  filter: drop-shadow(0 0.125rem 0.125rem rgba(15, 40, 80, 0.08));
  pointer-events: none;
}

.speed-picker-fade-enter-active,
.speed-picker-fade-leave-active {
  transition: opacity 0.15s ease;
}

.speed-picker-fade-enter,
.speed-picker-fade-leave-to {
  opacity: 0;
}

/* 占满一行，仅负责把内层推到右侧 */
.function-buttons-row {
  display: flex;
  justify-content: flex-end;
  box-sizing: border-box;
  margin-top: 0.2rem;
  position: absolute;
    bottom: 20rem;
    right: 0.75rem;
}

.function-buttons {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: max-content;
  max-width: 100%;
  box-sizing: border-box;
  gap: 0.5rem;
  padding: 0.5rem;
  background-color: #fffc;
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.75rem 0 rgba(0, 0, 0, 0.1);
  border: 0.0625rem solid #dcdfe6;
  font-size: 0.875rem;
}

.function-buttons__export {
  width: auto;
  flex: 0 0 auto;
}

/* 标签页样式 */
.el-tabs {
  background-color: #fffc;
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.75rem 0 rgba(0, 0, 0, 0.1);
  border: 0.0625rem solid #dcdfe6;
  overflow: hidden;
  padding: 0 0.625rem;
  margin-top: 0.2rem;

}

.el-tabs__header {
  margin: 0;
  padding: 0.5rem;
  background-color: #f5f7fa;
  border-bottom: 0.0625rem solid #e4e7ed;
}

.el-tabs__content {
  padding: 0.5rem;
  height: calc(100% - 2.5rem);
  overflow: auto;
}

.el-table {
  font-size: 0.75rem;
  height: 8rem;
  overflow: auto;
}

.el-table::before {
  height: 0 !important;
}

/* 表格区域设为纯白，避免地图在半透明面板下透出“线条”视觉 */
.el-table,
.el-table th,
.el-table td,
.el-table tr {
  background-color: #fff !important;
}

.el-table th,
.el-table td {
  padding: 0.375rem;
  height: 1.5rem;
  line-height: 1.5rem;
}

/* 确保表格内容不换行 */
.el-table .cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 限制表格容器高度 */
.el-tabs__content {
  padding: 0.5rem;
  overflow: hidden;
}

/* 限制表格主体高度 */
.el-table__body-wrapper {
  max-height: 5.25rem;
  overflow-y: auto;
}

/* 右侧监控区域展开状态 */
.right-panel.expanded {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-height: 100%;
  border-radius: 0;
  padding: 1rem;
  z-index: 1000;
}

/* 右侧监控区域隐藏状态 */
.right-panel.hidden {
  display: none;
}

/* 展开/收缩按钮样式 */
.expand-controls {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-left: auto;
  z-index: 99;
}

.expand-controls-fiex {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 9999;
  pointer-events: none;
  box-sizing: border-box;
}

.expand-controls-fiex .expand-btn {
  pointer-events: auto;
}

.expand-controls-top {
  position: absolute;
  top: 0.625rem;
  left: 50%;
  transform: translateX(-50%);
}

.expand-btn {
  width: 5rem;
  height: 1.2rem;
  padding: 0;
  background-color: #668bfa;
  border: none;
  border-radius: 0 0 1rem 1rem;
  -webkit-clip-path: polygon(0% 0%, 100% 0%, 92% 100%, 8% 100%);
  clip-path: polygon(0% 0%, 100% 0%, 92% 100%, 8% 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 11;
  transition: filter 0.2s ease;
  outline: none;
  text-align: center;
}

.expand-controls-bottom {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 1rem 1rem 0 0;
  -webkit-clip-path: polygon(8% 0%, 92% 0%, 100% 100%, 0% 100%);
  clip-path: polygon(8% 0%, 92% 0%, 100% 100%, 0% 100%);
}


.el-icon-video-pause {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
}

.export-dialog-body .el-checkbox {
  display: block;
  margin-bottom: 0.75rem;
}

.export-dialog-body .el-checkbox:last-of-type {
  margin-bottom: 0;
}

.export-regeo-progress-label {
  margin: 0.75rem 0 0;
  font-size: 0.875rem;
  color: #606266;
  text-align: center;
}

.trajectory-share-dialog-body {
  font-size: 0.875rem;
  color: #303133;
}

.trajectory-share-success-line {
  margin: 0 0 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.trajectory-share-go-link {
  color: #409eff;
  text-decoration: none;
}

.trajectory-share-go-link:hover {
  text-decoration: underline;
}

.trajectory-share-url-row {
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
}

.trajectory-share-url-input {
  flex: 1;
  min-width: 0;
}
</style>

<style scoped>
.quality-time-gaps { position: relative; height: 8px; background: #e4e7ed; }
.quality-time-gaps span { position: absolute; height: 8px; background: #909399; }
.right-data-el-table--quality ::v-deep .cell { white-space: nowrap; }
</style>
